<template>
  <div>
    <!-- <Cabecera></Cabecera> -->
    <main role="main">
      <!-- <StepNumbers></StepNumbers> -->
      <div class="c-steps-numbers">
        <div class="container">
          <div class="c-steps-numbers__item success">
            <span>1</span>
            <p>Información y<br />antecedentes legales</p>
          </div>
          <div class="c-steps-numbers__item success">
            <span>2</span>
            <p>Antecedentes<br />financieros</p>
          </div>
          <div class="c-steps-numbers__item success">
            <span>3</span>
            <p>Patrocinios</p>
          </div>
          <div class="c-steps-numbers__item active">
            <span>4</span>
            <p>Participación</p>
          </div>
          <div class="c-steps-numbers__item">
            <span>5</span>
            <p>Declaraciones<br />y compromisos</p>
          </div>
        </div>
      </div>
      <div class="c-form-steps">
        <!-- <div class="requestNumber">
          <p>SOLICITUD N° {{globalRequestNumber}}</p>
        </div> -->
        <div class="c-form-steps__sections greybg" data-step="04">
          <div class="container u-pb0">
            <div class="c-form-steps__content step-data">
              <div class="row">
                <div class="col-md-12 col-lg-6 offset-lg-2">
                  <h2>Representante ante la CChC</h2>
                  <p style="text-align: justify;">
                        <b>
                          Los socios personas jurídicas deberán designar una persona que actúe como su representante ante la Cámara, quien deberá tener la calidad de dueño, socio o accionista, director, representante legal o gerente general del respectivo socio, con plenas facultades para ejercer todos los derechos que le correspondan en su calidad de socio.
                        </b>
                  </p>
                  <p style="text-align: justify;">
                        <b>
                          El representante ante las Cámaras Regionales deberá ser el ejecutivo de más alto rango que el respectivo socio tenga en la zona.
                        </b>
                  </p>
                  <p style="text-align: justify;">
                        <b>
                          Será el principal nexo entre la empresa y la Cámara Chilena
                          de la Construcción para todos los eventos de comunicación
                          que se realicen.
                        </b>
                  </p>
                  
                  <form action="#" id="step06_1">
                      <div style="padding-bottom: 30px;">
                        <input
                          id="f1"
                          name="declaracion"
                          tabindex="31"
                          type="checkbox"
                          value="true"
                          v-model="dataRepresentante.declaracion"
                          @change="declaracionValidation(dataRepresentante)"
                          :disabled="!this.corregir"
                        />
                        <label for="f1">
                          <!-- <span class="label-input">Especialidades</span> -->
                          Conozco y acepto condiciones de postulación.
                        </label>
                        <div
                        id="declaracionst02-error"
                          class="errorDeclaracion"
                          v-if="declaracionIsValid === false"
                        >
                          Es obligatorio confirmar que has leído y aceptado las condiciones de postulación.
                        </div>
                      </div>
                        
                    <div class="input" ref="rut">
                      <label>RUT del representante</label>
                      <input
                        type="text"
                        tabindex="1"
                        name="rutrepresentante_st06"
                        v-model="dataRepresentante.rutRepre"
                        ref="rutRepresentante"
                        @focus="focus($refs.rut)"
                        @blur="
                          blur([$refs.rut, $refs.rutRepresentante.value]),
                            validateRutRepresentanteCchcExist(
                              $refs.rutRepresentante.value,
                              $refs.nombre,
                              $refs.apellido,
                              $refs.apellido2,
                              $refs.rutRepresentante,
                              $refs.nombreRepreCChc,
                              $refs.apellidoRepre,
                              $refs.apellidoRepre2
                            ),
                            buscarPersona($refs.rutRepresentante.value),
                            cleanInput()
                        "
                        @keyup="
                          rutRepresentanteCChCIsValidation(
                            $refs.rutRepresentante.value
                          )
                        "
                        :disabled="!this.corregir"
                      />
                      <div class="small-text">
                        Sin puntos y con guión (11111111-1)
                      </div>
                      <div
                        id="rutst02-error"
                        class="formerror"
                        v-if="rutRepresentanteCChCIsValid === false"
                      >
                        Ingrese un rut válido
                      </div>
                    </div>
                    <div class="input" ref="nombre">
                      <label>Nombre del representante</label>
                      <input
                        type="text"
                        tabindex="2"
                        maxlength="100"
                        name="nombrerepresentante_st06"
                        v-model="dataRepresentante.nombreRepre"
                        ref="nombreRepreCChc"
                        @focus="focus($refs.nombre)"
                        @blur="
                          blur([$refs.nombre, $refs.nombreRepreCChc.value])
                        "
                        :disabled="!this.corregir"
                      />
                    </div>
                    <div class="input" ref="apellido">
                      <label>Apellido Paterno del representante</label>
                      <input
                        type="text"
                        tabindex="3"
                        maxlength="100"
                        name="apellido1representante_st06"
                        v-model="dataRepresentante.apellidoRepre"
                        ref="apellidoRepre"
                        @focus="focus($refs.apellido)"
                        @blur="
                          blur([$refs.apellido, $refs.apellidoRepre.value])
                        "
                        :disabled="!this.corregir"
                      />
                    </div>
                    <div class="input" ref="apellido2">
                      <label>Apellido Materno del representante</label>
                      <input
                        type="text"
                        tabindex="4"
                        maxlength="100"
                        name="apellido2representante_st06"
                        v-model="dataRepresentante.apellidoRepre2"
                        ref="apellidoRepre2"
                        @focus="focus($refs.apellido2)"
                        @blur="
                          blur([$refs.apellido2, $refs.apellidoRepre2.value])
                        "
                        :disabled="!this.corregir"
                      />
                    </div>
                    <div class="input active" ref="tel">
                      <label>Teléfono (fijo) (<i>Opcional</i>)</label>
                      <input
                        type="text"
                        tabindex="5"
                        name="telefonorepresentante_st06"
                        v-model="dataRepresentante.telRepre"
                        ref="telRepreCChc"
                        @focus="focus($refs.tel)"
                        @blur="blur([$refs.tel, $refs.telRepreCChc.value])"
                        @keyup="
                          telRepresentanteCChCIsValidation(
                            $refs.telRepreCChc.value
                          )
                        "
                        :disabled="!this.corregir"
                      />
                      <div class="small-text">
                        Use el formato +56 0 0000 0000
                      </div>
                      <div
                        id="rutst02-error"
                        class="formerror"
                        v-if="telRepresentanteCChCIsValid === false"
                      >
                        Ingrese un teléfono válido
                      </div>
                    </div>
                    <div class="input active" ref="cel">
                      <label>Celular</label>
                      <input
                        type="text"
                        tabindex="6"
                        name="celularrepresentante_st06"
                        v-model="dataRepresentante.celRepre"
                        ref="celRepreCChc"
                        @focus="focus($refs.cel)"
                        @blur="blur([$refs.cel, $refs.celRepreCChc.value])"
                        @keyup="
                          celRepresentanteCChCIsValidation(
                            $refs.celRepreCChc.value
                          )
                        "
                        :disabled="!this.corregir"
                      />
                      <div class="small-text">
                        Use el formato +56 0 0000 0000
                      </div>
                      <div
                        id="rutst02-error"
                        class="formerror"
                        v-if="celRepresentanteCChCIsValid === false"
                      >
                        Ingrese un celular válido
                      </div>
                    </div>
                    <!--<div class="input datepicker" ref="fecha">
                      <label>Fecha de nacimiento</label>
                        <date-picker v-model="dataRepresentante.date" ref="fechaRepreCChc"
                        :lang="lang"
                        @focus="dateFocus($refs.fecha)"
                        @change="dateValidation($refs.fecha)"
                        valueType="format">
                      </date-picker>
                    </div>-->
                    <div class="input active" ref="email">
                      <label>Email de contacto</label>
                      <input
                        type="text"
                        tabindex="6"
                        name="emailrepresentante_st06"
                        v-model="dataRepresentante.emailRepre"
                        ref="emailRepreCChc"
                        @focus="focus($refs.email)"
                        @blur="blur([$refs.email, $refs.emailRepreCChc.value]),
                               sameMailValidation('dataRepresentante.emailRepre'),
                               findEmailExist($refs.emailRepreCChc.value, 'representanteCchc')"
                        @keyup="
                          emailRepresentanteCChCIsValidation(
                            $refs.emailRepreCChc.value
                          )
                        "
                        :disabled="!this.corregir"
                      />
                      <div
                        id="rutst02-error"
                        class="formerror"
                        v-if="emailRepresentanteCChCIsValid === false"
                      >
                        Ingrese un email válido
                      </div>
                    </div>
                    
                    <!-- Multiselect Area REPRESENTANTE ANTE LA CCHC aqui -->
                    <div ref="area"  class="input-select" :style="{ width: '360px' }">
                      <label :style="{ fontSize: '13px'}">Área/Gerencia</label>
                      <multiselect
                        v-model="dataRepresentante.area"
                        :max-height="500"
                        :options="areas.map(area => area.areaId)"
                        :custom-label="opt => areas.find(x => x.areaId == opt).areas"
                        placeholder="Seleccione las áreas correspondientes"
                        :multiple="true"
                        :searchable="true"
                        @input="setArea(dataRepresentante.area)"
                        ref="areaInput"
                        :disabled="!this.corregir"
                        selectLabel=""
                        deselectLabel="x"
                        selectedLabel="Seleccionada"
                        :style="{ width: '360px', fontSize: '18px' }"
                      ></multiselect>
                      <div
                        id="giro_st03-error"
                        class="errorlogin"
                        v-if="!validation.area"
                        :style="{ width: '100%', textAlign: 'right' }"
                      >
                        <p :style="{ color: 'red', fontSize: '10px', margin: '0' }">Seleccione al menos un Área</p>
                      </div>
                    </div>
                    <br>
                    <br>
                      <!-- select nativo guardando correctamente -->
                      <!-- <div class="input active" ref="area">
                      <label>Área/Gerencia</label>
                      <div class="input-select">
                        <select
                        multiple
                          tabindex="5"
                          name="cargo_st03"
                          ref="areaInput"
                          v-model="dataRepresentante.area"
                          :value="selectedAreas"
                          @change="
                            [
                              setArea(dataRepresentante.area), 
                            ]
                          "
                          :disabled="!this.corregir"
                        >
                          <option value="" selected disabled>
                            Seleccione un área
                          </option>
                          <option
                            v-for="(area, key) in areas"
                            :value="area.areaId"
                            :key="key"
                          >
                            {{ area.areas }}
                          </option>
                        </select>
                        <div
                          id="giro_st03-error"
                          class="errorlogin"
                          v-if="!validation.area"
                        >
                          Ingrese un Area
                        </div>
                      </div>
                    </div> -->





                    <!-- nuevo campo aqui -->
                    <!-- <div class="input active" ref="area">
  <label>Área/Gerencia</label>
  <div class="input-select">
    <multiselect
      v-model="dataRepresentante.area"
      :options="areas"
      label="areas"
      track-by="areaId"
      placeholder="Seleccione un área"
      :multiple="true"
      :disabled="!this.corregir"
      @input="setArea(dataRepresentante.area)"
      :searchable="false"
      :clear-on-select="true"
      :close-on-select="true"
    ></multiselect>
    <div id="giro_st03-error" class="errorlogin" v-if="!validation.area">
      Ingrese un Área
    </div>
  </div>
</div> -->


                    <div class="input active" ref="cargo">
                      <label>Cargo</label>
                      <div class="input-select">
                        <select
                          tabindex="5"
                          name="cargo_st03"
                          ref="cargoInput"
                          v-model="dataRepresentante.cargo"
                          :value="selectedCargos"
                          @keyup="[
                            setCargo($refs.cargoInput.value),
                            CargoRepreLegalValidationIndex(dataRepresentante.cargo)
                          ]
                            
                          "
                          :disabled="!this.corregir"
                        >
                          <option value="" selected>
                            Seleccione un cargo
                          </option>
                          <option
                            v-for="(cargo, key) in cargos"
                            :value="cargo.cargoId"
                            :key="key"
                            :selected="cargo.cargoId === selectedCargos"
                          >
                            {{ cargo.cargos }}
                          </option>
                        </select>
                        <div
                          id="giro_st03-error"
                          class="errorlogin"
                          v-if="!validation.cargo"
                        >
                          Ingrese un Cargo
                        </div>
                      </div>
                    </div>

                    <div class="input active" ref="genero">
                      <label>Sexo</label>
                      <div class="input-select">
                        <select
                          tabindex="5"
                          name="cargo_st03"
                          ref="sexoInput"
                          v-model="dataRepresentante.genero"
                          @input="$event = setSexo($event.target.value)"
                          @keyup="SexoValidationIndex(dataRepresentante.genero)"
                          :disabled="!this.corregir"
                          :value="selectedSexo"
                        >
                          <option value="" selected>
                            Seleccione un género
                          </option>
                          <option
                            v-for="(item, option) in options"
                            :key="option"
                            :value="item.value"
                            :selected="item.value === selectedSexo"
                          >
                            {{ item.text }}
                          </option>
                        </select>
                        <!-- <p>{{dataRepresentante.genero}}</p>-->
                        <div
                          id="girost03"
                          class="formerror"
                          v-if="!validation.sexo"
                        >
                          Ingrese un género
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="c-form-steps whitebg small" tabindex="8" ref="collapse">
            <div class="container u-pt40">
              <a
                class="section-minimizar"
                ref="collapseMin"
                @click="collapseClick([$refs.collapse, $refs.collapseMin])"
                >{{ collapse }}
              </a>
              <span
                tabindex="10"
                @keydown.tab="
                  collapseOnceStepTwo([$refs.collapse, $refs.collapseMin])
                "
              ></span>
              <div class="c-form-steps__content step-data u-pt0">
                <div class="row">
                  <div class="col-md-12 col-lg-6 offset-lg-2">
                    <form action="#" id="step06_2">
                      <h2 tabindex="9">Contacto DE cobranza</h2>
                      <p>
                        Será la persona encargada de gestionar el pago de cuotas
                        sociales ante la CChC.
                      </p>
                      <strong
                        >*Si desea cargar automáticamente los datos del
                        representante ante la CChC haga click en el siguiente
                        botón:</strong
                      >
                      <br /><br />
                      <div class="input-new">
                        <!-- <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Si desea cargar automáticamente los datos del representante ante la CChC haga click en el siguiente botón"> -->
                        <button
                          type="button"
                          tabindex="32"
                          class="btn-blue informacion"
                          id="submitStep06"
                          @click="loadRepresentanteCchc(1, 0)"
                        >
                          Usar datos del Representante ante la CChC
                        </button>
                        <!-- </span> -->
                      </div>
                      <div class="input" ref="rutContacto">
                        <label>RUT del contacto</label>
                        <input
                          type="text"
                          tabindex="11"
                          name="rutrepresentante02_st06"
                          v-model="dataContactoCobranza.rutContactoCob"
                          ref="rutContactoCob"
                          @focus="focus($refs.rutContacto)"
                          @blur="
                            blur([
                              $refs.rutContacto,
                              $refs.rutContactoCob.value,
                            ]),
                              validateRutContactoCobranzaExist(
                                $refs.rutContactoCob.value,
                                $refs.nombreContacto,
                                $refs.apellidoContacto,
                                $refs.apellidoMaContacto
                              ),
                              validateRutContactoCobranzaExist(
                                $refs.rutContactoCob.value,
                                $refs.nombreContacto,
                                $refs.apellidoContacto,
                                $refs.apellidoMaContacto
                              ),
                              buscarPersona($refs.rutContactoCob.value),
                              cleanInput()
                          "
                          @keyup="
                            rutContactoCobIsValidation(
                              $refs.rutContactoCob.value
                            )
                          "
                          :disabled="!this.corregir"
                        />
                        <div class="small-text">
                          Sin puntos y con guión (11111111-1)
                        </div>
                        <div
                          id="rutst02-error"
                          class="formerror"
                          v-if="rutContactoCobIsValid === false"
                        >
                          Ingrese un rut válido
                        </div>
                      </div>
                      <div class="input" ref="nombreContacto">
                        <label>Nombre del contacto</label>
                        <input
                          type="text"
                          tabindex="12"
                          maxlength="100"
                          name="nombrerepresentante02_st06"
                          v-model="dataContactoCobranza.nombreContactoCob"
                          ref="nombreContactoCob"
                          @focus="focus($refs.nombreContacto)"
                          @blur="
                            blur([
                              $refs.nombreContacto,
                              $refs.nombreContactoCob.value,
                            ])
                          "
                          :disabled="!this.corregir"
                        />
                      </div>
                      <div class="input" ref="apellidoContacto">
                        <label>Apellido Paterno del contacto</label>
                        <input
                          type="text"
                          tabindex="13"
                          maxlength="100"
                          name="apellido1representante02_st06"
                          v-model="dataContactoCobranza.apellidoContacto"
                          ref="apellidoContactoCob"
                          @focus="focus($refs.apellidoContacto)"
                          @blur="
                            blur([
                              $refs.apellidoContacto,
                              $refs.apellidoContactoCob.value,
                            ])
                          "
                          :disabled="!this.corregir"
                        />
                      </div>
                      <div class="input" ref="apellidoMaContacto">
                        <label>Apellido Materno del contacto</label>
                        <input
                          type="text"
                          tabindex="14"
                          maxlength="100"
                          name="apellido2representante02_st06"
                          v-model="dataContactoCobranza.apellidoMatContacto"
                          ref="apellidoMaContactoCob"
                          @focus="focus($refs.apellidoMaContacto)"
                          @blur="
                            blur([
                              $refs.apellidoMaContacto,
                              $refs.apellidoMaContactoCob.value,
                            ])
                          "
                          :disabled="!this.corregir"
                        />
                      </div>
                      <div class="input active" ref="telContacto">
                        <label>Teléfono (fijo) (<i>Opcional</i>)</label>
                        <input
                          type="text"
                          tabindex="15"
                          name="telefonorepresentante02_st06"
                          v-model="dataContactoCobranza.telContacto"
                          ref="telContactoCob"
                          @focus="focus($refs.telContacto)"
                          @blur="
                            blur([
                              $refs.telContacto,
                              $refs.telContactoCob.value,
                            ])
                          "
                          @keyup="
                            telContactoCobIsValidation(
                              $refs.telContactoCob.value
                            )
                          "
                          :disabled="!this.corregir"
                        />
                        <div class="small-text">
                          Use el formato +56 0 0000 0000
                        </div>
                        <div
                          id="rutst02-error"
                          class="formerror"
                          v-if="telContactoCobIsValid === false"
                        >
                          Ingrese un teléfono válido
                        </div>
                      </div>
                      <div class="input active" ref="celContacto">
                        <label>Celular </label>
                        <input
                          type="text"
                          tabindex="16"
                          name="celularrepresentante02_st06"
                          v-model="dataContactoCobranza.celContacto"
                          ref="celContactoCob"
                          @focus="focus($refs.celContacto)"
                          @blur="
                            blur([
                              $refs.celContacto,
                              $refs.celContactoCob.value,
                            ])
                          "
                          @keyup="
                            celContactoCobIsValidation(
                              $refs.celContactoCob.value
                            )
                          "
                          :disabled="!this.corregir"
                        />
                        <div class="small-text">
                          Use el formato +56 0 0000 0000
                        </div>
                        <div
                          id="rutst02-error"
                          class="formerror"
                          v-if="celContactoCobIsValid === false"
                        >
                          Ingrese un celular válido
                        </div>
                      </div>
                      <div class="input active" ref="emailContacto">
                        <label>Email de contacto</label>
                        <input
                          type="text"
                          tabindex="17"
                          name="emailrepresentante02_st06"
                          v-model="dataContactoCobranza.emailContacto"
                          ref="emailContactoCob"
                          @focus="focus($refs.emailContacto)"
                          @blur="
                            blur([
                              $refs.emailContacto,
                              $refs.emailContactoCob.value,
                            ]),
                            sameMailValidation('dataContactoCobranza.emailContacto'),
                            findEmailExist($refs.emailContactoCob.value, 'contactoCobranza')
                          "
                          @keyup="
                            emailContactoCobIsValidation(
                              $refs.emailContactoCob.value
                            )
                          "
                          :disabled="!this.corregir"
                        />
                        <div
                          id="rutst02-error"
                          class="formerror"
                          v-if="emailContactoCobIsValid === false"
                        >
                          Ingrese un email válido
                        </div>
                      </div>


                      <!-- multiselect area CONTACTO COBRANZA aqui -->
     
                      <div class="input-select"  ref="area" :style="{ width: '360px' }">
                      <label :style="{ fontSize: '13px'}">Área/Gerencia</label>
                      <multiselect
                        v-model="dataContactoCobranza.areaContacto"
                        :options="areas.map(area => area.areaId)"
                        :custom-label="opt => areas.find(x => x.areaId == opt).areas"
                        placeholder="Seleccione las áreas correspondientes"
                        :multiple="true"
                        :searchable="true"
                        @input="setAreaContactoCob(dataContactoCobranza.areaContacto)"
                        ref="areaContacto"
                        :disabled="!this.corregir"
                        selectLabel=""
                        deselectLabel="x"
                        selectedLabel="Seleccionada"
                        :style="{ width: '360px', fontSize: '18px' }"
                      ></multiselect>
                      <div
                        id="area_contacto_error"
                        class="errorlogin"
                        v-if="!validation.area"
                        :style="{ width: '100%', textAlign: 'right' }"
                      >
                        <p :style="{ color: 'red', fontSize: '10px', margin: '0' }">Seleccione al menos un Área</p>
                      </div>
                    </div>
                    <br>
                    <br>


                      
                   <!--  <div class="input active" ref="areaContacto">
                      <label>Área/Gerencia</label>
                      <div class="input-select">
                        <select                        
                          tabindex="5"
                          name="cargo_st03"
                          ref="areaContacto"
                          v-model="dataContactoCobranza.areaContacto"
                          :value="selectedAreaContacto"
                          @change="
                            [
                              setAreaContactoCob(dataContactoCobranza.areaContacto),  
                              //getCargosCob(),
                              //cargoContactoSetDefaultValues(),
                              //areaValidation(),
                              //areaSetDefaultValues(),
                            ]
                          "
                          :disabled="!this.corregir"
                        >
                          <option value="" selected disabled>
                            Seleccione un área
                          </option>
                          <option
                            v-for="(area, key) in areas"
                            :value="area.areaId"
                            :key="key"
                          >
                            {{ area.areas }}
                          </option>
                        </select>
                        <div
                          id="giro_st03-error"
                          class="errorlogin"
                          v-if="!validation.area"
                        >
                          Ingrese un Area
                        </div>
                      </div>
                    </div> -->


                    <div class="input active" ref="cargo">
                      <label>Cargo</label>
                      <div class="input-select">
                        <select
                          tabindex="5"
                          name="cargo_st03"
                          ref="cargoContacto"
                          v-model="dataContactoCobranza.cargoContacto"
                          :value="selectedCargos"
                          @keyup="[
                            setCargo(dataContactoCobranza.cargoContacto),
                            CargoRepreLegalValidationIndex(dataRepresentante.cargo)
                          ]
                            
                          "
                          :disabled="!this.corregir"
                        >
                          <option value="" selected>
                            Seleccione un cargo
                          </option>
                          <option
                            v-for="(cargo, key) in cargos"
                            :value="cargo.cargoId"
                            :key="key"
                            :selected="cargo.cargoId === selectedCargos"
                          >
                            {{ cargo.cargos }}
                          </option>
                        </select>
                        <div
                          id="giro_st03-error"
                          class="errorlogin"
                          v-if="!validation.cargo"
                        >
                          Ingrese un Cargo
                        </div>
                      </div>
                    </div>

                      


                      <br />
                      <div class="input active" ref="generoContacto">
                        <label>Sexo</label>
                        <div class="input-select">
                          <select
                            tabindex="5"
                            name="sexo_st04"
                            ref="generoContacto"
                            v-model="dataContactoCobranza.generoContacto"
                            @input="
                              $event = setSexoContact($event.target.value)
                            "
                            :value="selectedSexoContact"
                            @keyup="
                              SexoValidationIndexContacto(
                                $refs.generoContacto.value
                              )
                            "
                            :disabled="!this.corregir"
                            @keydown.tab="
                              collapseStepFour([
                                $refs.collapse2,
                                $refs.collapseMin2,
                              ])
                            "
                          >
                            <!-- <option value="" selected disabled hidden> -->
                            <option value="" selected>
                              Seleccione un género
                            </option>
                            <option
                              v-for="(item, option) in options"
                              :key="option"
                              :value="item.value"
                              :selected="item.value === selectedSexoContact"
                            >
                              {{ item.text }}
                            </option>
                          </select>
                          <!-- <p>{{ dataContactoCobranza.generoContacto}}</p>-->
                          <div
                            id="giro_st03-error"
                            class="errorlogin"
                            v-if="!validation.contacto.sexo"
                          >
                            Ingrese un género
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="c-form-steps greybg small" tabindex="18" ref="collapse2">
            <div class="container u-pt10 u-pb60">
              <a
                class="section-minimizar"
                ref="collapseMin2"
                @click="collapseClick([$refs.collapse2, $refs.collapseMin2])"
                >{{ collapse }}
              </a>
              <span
                tabindex="20"
                @keydown.tab="
                  collapseStepFour([$refs.collapse2, $refs.collapseMin2])
                "
              ></span>
              <div class="c-form-steps__content step-data u-pb0">
                <div class="row">
                  <div class="col-md-12 col-lg-6 offset-lg-2">
                    <form action="#" id="step06_3">
                      <h2 tabindex="19">REPRESENTANTE LEGAL</h2>
                      <div class="content-repeater" id="repeater">
                        <div class="wrapper-repeater">
                          <div v-for="(item, index) in inputs" :key="index">
                            <strong
                              >*Si desea cargar automáticamente los datos del
                              representante ante la CChC o del contacto de
                              Cobranza haga click en uno de los botones
                              desplegados a continuación:</strong
                            >
                            <br /><br />
                            <div class="input-new">
                              <!-- cargar contacto-->
                              <div>
                                <button
                                  type="button"
                                  tabindex="32"
                                  class="btn-blue informacion"
                                  id="buttonCchc"
                                  @click="loadRepresentanteCchc(2, index)"
                                >
                                  Usar datos del Representante ante la CChC
                                </button>
                              </div>
                              <div>
                                <button
                                  type="button"
                                  style="margin-left:5px;"
                                  tabindex="32"
                                  class="btn-blue informacion"
                                  id="buttonCobranza"
                                  @click="loadContactoCobranza(index)"
                                >
                                  Usar datos del Contacto de Cobranza
                                </button>
                              </div>

                              <!-- cargar contacto fin -->
                            </div>
                            <div class="input" ref="rutRepre2">
                              <label
                                >RUT del representante<i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <input
                                type="text"
                                tabindex="21"
                                name="rutrepresentante03_st06"
                                id="index"
                                ref="rutRepreLeg2"
                                @focus="focus($refs.rutRepre2[index])"
                                @blur="
                                  blur([
                                    $refs.rutRepre2[index],
                                    form.rutRepreLegal[index],
                                  ]),
                                    buscarPersona(form.rutRepreLegal[index]),
                                    cleanInput(index)
                                "
                                v-model="form.rutRepreLegal[index]"
                                @keyup="
                                  rutRepreLegalIsValidation(
                                    form.rutRepreLegal[index]
                                  )
                                "
                                @change="
                                  validateRutRepresentanteLegalFormExist(
                                    form.rutRepreLegal[index],
                                    index,
                                    $refs.nombreRepre2[index],
                                    $refs.apePatRepre2[index],
                                    $refs.apeMatRepre2[index],
                                    $refs.nombreRepreLeg2[index],
                                    $refs.apePatRepreLeg2[index],
                                    $refs.apeMatRepreLeg2[index],
                                    $refs.rutRepreLeg2[index]
                                  )
                                "
                              />
                              <div class="small-text">
                                Sin puntos y con guión (11111111-1)
                              </div>
                              <div
                                id="rutst02-error"
                                class="formerror"
                                v-if="rutRepreLegalIsValid === false"
                              >
                                Ingrese un rut válido
                              </div>
                            </div>

                            <div class="input" ref="nombreRepre2">
                              <label
                                >Nombre del representante<i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <input
                                type="text"
                                tabindex="22"
                                maxlength="100"
                                name="nombrerepresentante03_st06"
                                ref="nombreRepreLeg2"
                                @focus="focus($refs.nombreRepre2[index])"
                                @blur="
                                  blur([
                                    $refs.nombreRepre2[index],
                                    form.nomRepreLegal[index],
                                  ])
                                "
                                v-model="form.nomRepreLegal[index]"
                              />
                            </div>

                            <div class="input" ref="apePatRepre2">
                              <label
                                >Apellido Paterno del representante<i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <input
                                type="text"
                                tabindex="23"
                                maxlength="100"
                                name="apellido1representante03_st06"
                                ref="apePatRepreLeg2"
                                @focus="focus($refs.apePatRepre2[index])"
                                @blur="
                                  blur([
                                    $refs.apePatRepre2[index],
                                    form.apePatRepreLegal[index],
                                  ])
                                "
                                v-model="form.apePatRepreLegal[index]"
                              />
                            </div>

                            <div class="input" ref="apeMatRepre2">
                              <label
                                >Apellido Materno del representante<i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <input
                                type="text"
                                tabindex="24"
                                maxlength="100"
                                name="apellido2representante03_st06"
                                ref="apeMatRepreLeg2"
                                @focus="focus($refs.apeMatRepre2[index])"
                                @blur="
                                  blur([
                                    $refs.apeMatRepre2[index],
                                    form.apeMatReprelegal[index],
                                  ])
                                "
                                v-model="form.apeMatReprelegal[index]"
                              />
                            </div>

                            <div class="input active" ref="telRepre2">
                              <label
                                >Teléfono (fijo)<i>
                                  (<i>Opcional</i>) (<i class="contador">{{
                                    index + 1
                                  }}</i>
                                  de <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <input
                                type="text"
                                tabindex="25"
                                name="telefonorepresentante03_st06"
                                ref="telRepreLeg2"
                                value="+56"
                                @focus="focus($refs.telRepre2[index])"
                                @blur="
                                  blur([
                                    $refs.telRepre2[index],
                                    form.telRepreLegal[index],
                                  ])
                                "
                                @keyup="
                                  telRepreLegalIsValidation(
                                    form.telRepreLegal[index]
                                  )
                                "
                                v-model="form.telRepreLegal[index]"
                              />
                              <div class="small-text">
                                Use el formato +56 0 0000 0000
                              </div>
                              <div
                                id="rutst02-error"
                                class="formerror"
                                v-if="telRepreLegalIsValid === false"
                              >
                                Ingrese un teléfono válido
                              </div>
                            </div>

                            <div class="input active" ref="celRepre2">
                              <label
                                >Celular<i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <input
                                type="text"
                                tabindex="26"
                                name="celularrepresentante03_st06"
                                ref="celRepreLeg2"
                                @focus="focus($refs.celRepre2[index])"
                                @blur="
                                  blur([
                                    $refs.celRepre2[index],
                                    form.celRepreLegal[index],
                                  ])
                                "
                                @keyup="
                                  celRepreLegalIsValidation(
                                    form.celRepreLegal[index]
                                  )
                                "
                                v-model="form.celRepreLegal[index]"
                              />
                              <div class="small-text">
                                Use el formato +56 0 0000 0000
                              </div>
                              <div
                                id="rutst02-error"
                                class="formerror"
                                v-if="celRepreLegalIsValid === false"
                              >
                                Ingrese un celular válido
                              </div>
                            </div>

                            <div class="input active" ref="emailRepre2">
                              <label
                                >Mail de contacto<i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <input
                                type="text"
                                tabindex="27"
                                name="emailrepresentante03_st06"
                                ref="emailRepreLeg2"
                                @focus="focus($refs.emailRepre2)"
                                @blur="
                                  blur([
                                    $refs.emailRepre2[index],
                                    form.emailRereLegal[index],
                                  ]),
                                  sameMailValidation('form.emailRereLegal[index]'),
                                  findEmailExist(form.emailRereLegal[index], 'representanteLegal', index)
                                "
                                @keyup="
                                  emailRepreLegalIsValidation(
                                    form.emailRereLegal[index]
                                  )
                                "
                                v-model="form.emailRereLegal[index]"
                              />
                              <div
                                id="rutst02-error"
                                class="formerror"
                                v-if="emailRepreLegalIsValid === false"
                              >
                                Ingrese un email válido
                              </div>
                            </div>


                        <!-- nuevo campo REPRESENTANTE LEGAL aqui -->
                        <div class="input-select"  ref="area">                
                        <label :style="{ fontSize: '12px'}">Área/Gerencia<i>
                        (<i class="contador">{{ index + 1 }}</i> de
                        <i class="total">{{ inputs.length }}</i>)</i></label>
                        <multiselect
                          v-model="form.area[index]"
                          :options="areas.map(area => area.areaId)"
                          :custom-label="opt => areas.find( x => x.areaId == opt).areas"
                          placeholder="Seleccione las áreas correspondientes"
                          :multiple="true"
                          :searchable="true"
                          @input="setAreaRepreLegal(form.area[index])"
                          ref="areaRepre2"
                          selectLabel=""
                          deselectLabel="x"
                          selectedLabel="Seleccionada"
                          :style="{ width: '360px', fontSize: '18px' }"
                        ></multiselect>
                        </div>
                        <br>
                        <br>






                          <!-- nuevo campo REPRESENTANTE LEGAL aqui -->
                           <!--  <div class="input active" ref="areaRepre2">
                              <label>Area/Gerencia<i>
                                          (<i class="contador">{{ index + 1 }}</i> de
                                          <i class="total">{{ inputs.length }}</i
                                          >)</i
                                      ></label
                              >
                              <div class="input-select">
                                <select
                                  
                                  tabindex="5"
                                  name="cargo_st03"
                                  ref="areaRepre2"
                                  v-model="form.area[index]"
                                  :value="selectedAreasRepreLegal"
                                  @change="
                                    [
                                    setAreaRepreLegal(form.area[index]),
                                    //getCargosRepreLegal(index),
                                    //cargoRepreLegalSetDefaultValues(),
                                      //areaValidation(),
                                      //areaSetDefaultValues(),
                                    ]
                                  "
                                  
                                >
                                  <option value="" selected disabled>
                                    Seleccione un área
                                  </option>
                                  <option
                                    v-for="(area, key) in areas"
                                    :value="area.areaId"
                                    :key="key"
                                    :selected="area.areaId === selectedAreasRepreLegal"
                                  >
                                    {{ area.areas }}
                                  </option>
                                </select>
                                <div
                                  id="giro_st03-error"
                                  class="errorlogin"
                                  v-if="!validation.repre.area"
                                >
                                  Ingrese un Area
                                </div>
                              </div>
                            </div>
 -->

                            <div class="input active" ref="cargoRepre2">
                              <label
                                >Cargo
                                <i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <div class="input-select">
                                <select
                                  tabindex="5"
                                  name="cargo_st03"
                                  id="cargo_st03"
                                  ref="cargoRepre2"
                                  v-model="form.cargo[index]"
                                  :value="selectedCargoRepre"
                                  @change="[
                                    setCargoRepre($refs.cargoRepre2.value),
                                    CargoRepreLegalValidationIndex(
                                      form.cargo[index]
                                    )
                                  ]       
                                  "
                                >
                                  >
                                  <option value="" selected
                                    >Seleccione un cargo</option
                                  >
                                  <option
                                    v-for="(cargo, key) in cargos"
                                    :value="cargo.cargoId"
                                    :key="key"
                                    :selected="
                                      cargo.cargoId === form.cargo[index]
                                    "
                                  >
                                    {{ cargo.cargos }}
                                  </option>
                                </select>
                                <div
                                  id="rutst02-error"
                                  class="formerror"
                                  v-if="!validation.repre.cargo"
                                >
                                  Ingrese un cargo
                                </div>
                              </div>
                            </div>

                            <div class="input active" ref="generoRepre">
                              <label
                                >Sexo
                                <i>
                                  (<i class="contador">{{ index + 1 }}</i> de
                                  <i class="total">{{ inputs.length }}</i
                                  >)</i
                                ></label
                              >
                              <div class="input-select" ref="generoRepre">
                                <select
                                  tabindex="5"
                                  name="genero_st03"
                                  ref="generoRepreLeg2"
                                  v-model="form.gender[index]"
                                  @input="
                                    $event = setSexoRepre($event.target.value)
                                  "
                                  :value="selectedSexoRepre"
                                  @keyup="
                                    SexoValidationIndexRepreLeg2(
                                      form.gender[index]
                                    )
                                  "
                                >
                                  <option value="" selected>
                                    Seleccione un género
                                  </option>
                                  <option
                                    v-for="(item, option) in options"
                                    :key="option"
                                    :value="item.value"
                                    :selected="item.value === selectedSexoRepre"
                                  >
                                    {{ item.text }}
                                  </option>
                                </select>
                                <!-- <p>{{ form.generoRepreLegal[index] }}</p>-->

                                <div
                                  id="rutst02-error"
                                  class="formerror"
                                  v-if="!validation.repre.sexo"
                                >
                                  Ingrese un género
                                </div>
                              </div>
                            </div>
                            <!-- </div>-->
                            <!-- </div>-->

                            <div>
                              <button
                                class="link prev btn-red u-mt20 u-mr30 small"
                                type="button"
                                v-if="inputs.length > 0 && index > 0"
                                @click="deleteSocio(inputs.length - 1, index)"
                              >
                                Eliminar socio<span>x</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <a
                          class="input-repeater"
                          @click="addInput(inputs.length - 1)"
                          id="repeater-add-btn"
                          >Añadir otro representante legal<span>+</span></a
                        >
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  <div class="c-form-steps whitebg small" ref="collapse3" tabindex="28">
            <div class="container">
              <a class="section-minimizar" ref="collapseMin3" @click="collapseClick([$refs.collapse3, $refs.collapseMin3])">{{collapse}}
              </a>
              <span tabindex="30" @keydown.tab="collapseOnceStepTwo([$refs.collapse3, $refs.collapseMin3])"></span>
              <div class="c-form-steps__content step-data">
                <div class="row">
                  <div class="col-md-10 col-lg-10 offset-lg-2">
                    <form action="#" id="step06_4">
                      <h2 tabindex="29">selección de comités</h2>
                      <p class="small">Seleccione un comité en el que desee inscribirse, según la actividad principal de su empresa. Apoye su selección en la descripción de cada comité.</p>
                      <div class="row">
                        <div class="col-lg-4">
                          <h3>Infraestructura</h3>
                          <div class="md-checkbox">
                            
                            <input id="i1" name="comites" type="radio" value="true" v-model="dataComites.contratista" @click="setContratista()"
                            :disabled="!this.corregir">
                            <label for="i1"><span class="label-input">Contratistas Generales</span><span aria-label=""  @click="show('contratistas-generales')" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                          <div class="md-checkbox">
                            <input id="i2" name="comites" type="radio" value="true"  v-model="dataComites.obras" @click="setObras()" :disabled="!this.corregir">
                            <label for="i2"><span class="label-input">Obras Infraestructura Pública</span><span aria-label="" @click="show('obras-infra')" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                          <div class="md-checkbox">
                            <input id="i3" name="comites" type="radio" value="true" v-model="dataComites.concesiones" @click="setConcesiones()" :disabled="!this.corregir">
                            <label for="i3"><span class="label-input">Concesiones</span><span aria-label="" @click="show('concesiones')" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <h3>Vivienda</h3>
                          <div class="md-checkbox">
                            <input id="i4" name="comites" type="radio" value="true" v-model="dataComites.inmobiliario" @click="setInmobiliario()" :disabled="!this.corregir"
                            >
                            <label for="i4"><span class="label-input">Inmobiliario</span><span aria-label="" @click="show('inmobiliario')" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                          <div class="md-checkbox">
                            <input id="i5" name="comites" type="radio" value="true" v-model="dataComites.vivienda" @click="setVivienda()"
                            :disabled="!this.corregir"
                            >
                            <label for="i5"><span class="label-input">Vivienda</span><span @click="show('vivienda')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <h3>Suministros</h3>
                          <div class="md-checkbox">
                            <input id="i6" name="comites" type="radio" value="true" v-model="dataComites.proveedores" @click="setProveedores()"
                            :disabled="!this.corregir"
                            >
                            <label for="i6"><span class="label-input">Proveedores</span><span @click="show('proveedores')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                          <div class="md-checkbox">
                            <input id="i7" name="comites" type="radio" value="true" v-model="dataComites.industriales" @click="setIndustriales()"
                            :disabled="!this.corregir"
                            >
                            <label for="i7"><span class="label-input">Industriales</span><span @click="show('industriales')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                          <div class="md-checkbox">
                            <input id="i8" name="comites" type="radio" value="true" v-model="dataComites.especialidades" @click="setEspecialidades()"
                            :disabled="!this.corregir"
                            >
                            <label for="i8"><span class="label-input">Especialidades</span><span @click="show('especialidades')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <div class="c-form-steps whitebg">
            <div class="container">
              <div class="c-form-steps__content step-data">
                <div class="row">
                  <div class="col-md-10 col-lg-10 offset-lg-2">
                    <form action="#" id="step06_4">
                      <button
                        class="link prev btn-blue u-mt50 u-mr30 small"
                        type="button"
                        @click="anterior(), scrollToTop()"
                      >
                        <i class="fa fa-angle-left"></i>Anterior
                      </button>
                      <div
                        v-if="!this.tieneCorreccion"
                        style="display: inline;"
                      >
                        <button
                          type="button"
                          tabindex="31"
                          class="link btn-red u-mt50 big"
                          id="submitStep06"
                          style="margin-right: 25px;"
                          @click="save"
                        >
                          Guardar<i class="fa fa-angle-right"></i>
                        </button>
                      </div>

                      <button
                        type="button"
                        tabindex="32"
                        class="link btn-red u-mt50 big"
                        id="submitStep06"              
                        @click="saveContinue(), scrollToTop(), declaracionValidation(declaracionIsValid)"
                        v-if="formLoaded == true"
                      >
                        Continuar<i class="fa fa-angle-right"></i>
                      </button>
                      <button
                        type="button"
                        tabindex="32"
                        class="link btn-red u-mt50 big"
                        id="submitStep06"              
                        @click="saveContinue(), scrollToTop()"
                        :disabled="!formLoaded"
                        v-if="formLoaded == false"
                      >
                        Continuar<i class="fa fa-angle-right"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modales para comites -->
      <modal name="contratistas-generales" :height="400">
        <a
          class="close-modal-text"
          @click="$modal.hide('contratistas-generales')"
          >X</a
        >
        <h2>Contratistas Generales</h2>
        <br />
        <p>
          Agrupa empresas de ingeniería y de construcción que evalúan, estudian,
          diseñan y ejecutan obras de infraestructura pública y privada, de
          edificación no habitacional, y obras industriales en general. Su labor
          se orienta a búsqueda de soluciones para el sector, especialmente en
          lo que se refiere a las relaciones contractuales de sus socios con
          mandantes, subcontratistas, proveedores y trabajadores, buscando que
          imperen normas éticas y de equidad que aseguren la libre competencia.
          El Comité investiga las tendencias de inversiones sectoriales y
          entrega información de interés para orientar a las empresas del
          sector, principalmente en el logro de la calidad de las obras,
          cumplimientos de los plazos y de la seguridad de sus trabajadores.
        </p>
      </modal>

      <modal name="obras-infra" :height="400">
        <a class="close-modal-text" @click="$modal.hide('obras-infra')">X</a>
        <h2>Obras Infraestructura Pública</h2>
        <br />
        <p>
          Agrupa a empresas de construcción, de ingeniería y de consultoría
          relacionadas con los contratos de obras de infraestructura de uso
          público (carreteras, puentes, obras hidráulicas, arquitectura,
          concesiones, obras sanitarias, ferroviarias, etc). Su labor está
          orientada al estudio de las inversiones proyectadas por el MOP y otros
          mandantes de infraestructura de uso público. Analiza las condiciones
          generales de contratación buscando relaciones contractuales que
          favorezcan la equidad, transparencia y la incorporación de innovación
          tecnológica en los procesos constructivos. Mantiene una permanente
          relación con los diferentes mandantes de infraestructura de uso
          público (MOP, Empresas Sanitarias, Metro S.A., entre otras).
        </p>
      </modal>

      <modal name="concesiones" :height="400">
        <a class="close-modal-text" @click="$modal.hide('concesiones')">X</a>
        <h2>Concesiones</h2>
        <br />
        <p>
          Agrupa a las empresas concesionarias de obras de infraestructura de
          uso público y de servicios, con el objeto de representar los intereses
          de las grandes, medianas y pequeñas concesionarias que operan en este
          ámbito. Sus principales líneas de acción contemplan el
          perfeccionamiento de la institucionalidad de las concesiones y la
          ampliación de su ámbito de aplicación; la participación en el debate
          formativo que afecta a este sector; procurar agilidad en la
          tramitación de los decretos y en el cumplimiento de los calendarios de
          licitaciones, así como el desarrollo de otras iniciativas que permitan
          posicionar esta industria e incrementar la inversión en el ámbito de
          la infraestructura pública.
        </p>
      </modal>

      <modal name="inmobiliario" :height="400">
        <a class="close-modal-text" @click="$modal.hide('inmobiliario')">X</a>
        <h2>Inmobiliario</h2>
        <br />
        <p>
          Agrupa a empresas inmobiliarias, constructoras, instituciones
          financieras, corredores de propiedades, arquitectos y otros
          profesionales relacionados con el mercado Inmobiliario. Tiene por
          finalidad estudiar la oferta y demanda de bienes raíces, mantener el
          flujo de información sobre necesidades, requerimientos y condiciones
          del mercado inmobiliario, como, asimismo, el análisis de la normativa
          referente al desarrollo urbano.
        </p>
      </modal>

      <modal name="vivienda" :height="400">
        <a class="close-modal-text" @click="$modal.hide('vivienda')">X</a>
        <h2>Vivienda</h2>
        <br />
        <p>
          Agrupa a empresas que se dedican a la construcción y venta de
          viviendas con subsidio otorgados por el Ministerio de Vivienda y
          Urbanismo (MINVU) y otras instituciones públicas o privadas. Le
          corresponde el tratamiento de todas las materias vinculadas con la
          vivienda subsidiada, especialmente: materias relacionadas con la
          actividad del MINVU, incluida la vialidad urbana; subsidio
          habitacional; materias relacionadas con otros programas, tales como
          lotes con servicio del Ministerio del Interior, obras de construcción
          de viviendas o de urbanización de iniciativa municipal, etc.
        </p>
      </modal>

      <modal name="proveedores" :height="400">
        <a class="close-modal-text" @click="$modal.hide('proveedores')">X</a>
        <h2>Proveedores</h2>
        <br />
        <p>
          Agrupa a empresas distribuidoras y proveedoras de materiales de
          construcción del país. Desarrolla una labor de promoción, difusión e
          intercambio de información, y realiza estudios sobre el mercado de la
          demanda de productos.
        </p>
      </modal>

      <modal name="industriales" :height="400">
        <a class="close-modal-text" @click="$modal.hide('industriales')">X</a>
        <h2>Industriales</h2>
        <br />
        <p>
          Agrupa a empresas industriales, en su mayoría dedicadas a la
          producción y comercialización de bienes y servicios, cuyo principal
          destinatario es el sector de la construcción. Constituye la instancia
          para canalizar las inquietudes del sector industrial, obtener
          información respecto de la coyuntura económica, laboral, de seguridad
          industrial, medio ambiental y toda otra materia que de alguna forma
          pueda influir en el quehacer de la industria de la construcción en
          nuestro país.
        </p>
      </modal>

      <modal name="especialidades" :height="400">
        <a class="close-modal-text" @click="$modal.hide('especialidades')">X</a>
        <h2>Especialidades</h2>
        <br />
        <p>
          Agrupa a empresas y profesionales especializados en los diferentes
          procesos constructivos, principalmente en las áreas de proyectos,
          confección e instalación. Su labor fundamental es promover el uso de
          nuevas tecnologías, equipamiento y servicios de la más alta calidad.
        </p>
      </modal>
    </main>
  </div>
</template>

<script>
import Cabecera from "./../../components/Cabecera";
import StepNumbers from "./../../components/StepNumbers";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
//axios
import axios from "axios";
import VueAxios from "vue-axios";
//Vue Datepicker
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect'
//import 'vue-multiselect/dist/vue-multiselect.min.css';
//import Multiselect from 'vue-multiselect';



export default {
  name: "StepFour",
  components: {
    Cabecera,
    StepNumbers,
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      personaEncontrada: false,
      representanteLegalActivo: "",
      cargoRepreLeg2: "",
      areaInput: "",
      areaCargo:"",
      cargoInput: "",
      data: [{}],
      dataValidaciones: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          weekdaysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
        },
      },
      options: [
        { text: "Masculino", value: "2" },
        { text: "Femenino", value: "1" },
        { text: "Sin especificar", value: "3" },
      ],

      //Data form representante
      dataRepresentante: {
        declaracion: false,
        rutRepre: "",
        nombreRepre: "",
        apellidoRepre: "",
        apellidoRepre2: "",
        telRepre: "+56",
        celRepre: "+56",
        emailRepre: "",
        date: "",
        area: [],
        cargo: "",
        genero: "",
      },
      dateIsValid: "",
      AreaIsValid: "",
      CargoIsValid: "",
      CargoContactoIsValid: "",
      CargoRepreIsValid: "",

      //Data form contacto de cobranza
      dataContactoCobranza: {
        rutContactoCob: "",
        nombreContactoCob: "",
        apellidoContacto: "",
        apellidoMatContacto: "",
        telContacto: "+56",
        celContacto: "+56",
        emailContacto: "",
        areaContacto:[],
        cargoContacto: "",
        generoContacto: "",
      },

      //Data representante legal
      inputs: [
        {
          form: {
            rutRepreLegal: [],
            nomRepreLegal: [],
            apePatRepreLegal: [],
            apeMatReprelegal: [],
            telRepreLegal: ["+56"],
            celRepreLegal: ["+56"],
            //dateRepreLegal: [],
            emailRereLegal: [],
            area: [],
            cargo: [],
            gender: [],
            listCargos:[]
          },
        },
      ],
      dataRepreLegal: {
        form: {
          rutRepreLegal: [],
          nomRepreLegal: [],
          apePatRepreLegal: [],
          apeMatReprelegal: [],
          telRepreLegal: ["+56"],
          celRepreLegal: ["+56"],
          //dateRepreLegal: [],
          emailRereLegal: [],
          area:[],
          cargo: [],
          gender: [],
        },
      },
      form: {
        rutRepreLegal: [],
        nomRepreLegal: [],
        apePatRepreLegal: [],
        apeMatReprelegal: [],
        telRepreLegal: ["+56"],
        celRepreLegal: ["+56"],
        //dateRepreLegal: [],
        emailRereLegal: [],
        area:[],
        cargo: [],
        gender: [],
      },
      contador: 1,
      total: 1,
      //Data form comites
      dataComites: {
        contratista: false,
        obras: false,
        concesiones: false,
        inmobiliario: false,
        vivienda: false,
        proveedores: false,
        industriales: false,
        especialidades: false,
      },
      getStepFour: [],
      rutPatrocinateValid: "",
      objectDataRepreLegal: {},
      storeObjectStepFour: [""],
      banderaActivarClases: "",
      urlBase: this.$store.state.URL,
      posicionRepresentante: "",
      corregir: true,
      tieneCorreccion: false,
      contadorRLcchc: 0, // contadores para controlar el numero de copias en representante legal
      contadorRLcobranza: 0, // contadores para controlar el numero de copias en representante legal
      contenedorIndiceRlcchc: "",
      contenedorIndiceRlcobranza: "",
      camposIncompletosCchc: [],
      camposIncompletosCobranza: [],
      camposInvalidosCchc: [],
      camposInvalidosCobranza: [],
      formLoaded: false,
      declaracionIsValid: "",
    };
  },
  methods: {
    ...mapMutations([
      "focus",
      "blur",
      "collapseClick",
      "collapseOnceStepTwo",
      "collapseStepFour",
      "rutValidation",
      "phoneNumberValidation",
      "emailValidation",
      "saveCompletedForm",
      "dateFocus",
      "dateBlur",
      "setStepThreeValue",
      "setStepFourValue",
      "setStepFiveValue",
      "setArea",
      "setAreaContacto",
      "setAreaContactoCob",
      "setAreaLeg2",
      "setAreaRepreLegal",
      "setCargo",
      "setCargoCob",
      "setCargoContactoCob",
      "setCargoContacto",
      "setCargoLeg2",
      "setCargoRepre",
      "setSexo",
      "setSexoContact",
      "setSexoRepre",
      "rutRepresentanteCChCIsValidation",
      "rutContactoCobIsValidation",
      "rutRepreLegalIsValidation",
      "telRepresentanteCChCIsValidation",
      "telContactoCobIsValidation",
      "telRepreLegalIsValidation",
      "celRepresentanteCChCIsValidation",
      "celContactoCobIsValidation",
      "celRepreLegalIsValidation",
      "emailRepresentanteCChCIsValidation",
      "emailContactoCobIsValidation",
      "emailRepreLegalIsValidation",
      "CargoInputValidationIndex",
      "AreaContactoCobranzaValidationIndex",
      "CargoRepreLegalValidationIndex",
      "SexoValidationIndex",
      "SexoValidationIndexContacto",
      "SexoValidationIndexRepreLeg2",
      "setObjetoStepFour",
      "sortedArrayAreas",
      "sortedArrayCargos",
    ]),
    ...mapGetters(["getterObjetoStepFour", "getterCargo", "getterCargoContactoCob","getterSexo", "getterArea"]),
    ...mapActions(["getCargos","getCargosCob", "getAreas", "getCargosRepreLegal"]),

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    customLabel(options) {
      return options; // Muestra solo el nombre del área
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      }
      this.tagOptions.push(tag)
      this.value.push(tag)
    },

    cargoSetDefaultValues() {
      if (this.selectedAreas) {
        this.dataRepresentante.cargo = "";
      }
    },
    cargoContactoSetDefaultValues() {
      if (this.selectedAreas) {
        this.dataContactoCobranza.cargoContacto = "";
      }
    },
    cargoRepreLegalSetDefaultValues() {
      if (this.selectedAreasRepreLegal) {
        console.log("seteando en 0 repre legal");
        console.log("seteando en 0 repre legal");
        this.selectedCargoRepre[index] = "";
      }
    },

    setContratista() {
      this.dataComites.obras = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false;
      this.dataComites.contratista = "true";
    },
    setObras() {
      this.dataComites.contratista = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false;
      this.dataComites.obras = "true";
    },
    setConcesiones() {
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false;
      this.dataComites.concesiones = "true";
    },
    setVivienda() {
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.concesiones = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.especialidades = false;
      this.dataComites.vivienda = "true";
    },
    setInmobiliario() {
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.especialidades = false;
      this.dataComites.inmobiliario = "true";
    },
    setProveedores() {
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false;
      this.dataComites.proveedores = "true";
    },

    setIndustriales() {
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.especialidades = this.dataComites.vivienda = false;
      this.dataComites.industriales = "true";
    },
    setEspecialidades() {
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.vivienda = false;
      this.dataComites.especialidades = "true";
      // this.dataComites.especialidades
    },

    buscarPersona(rut) {
        //console.log("entro a buscarPersona")
            // Verificar si el RUT está vacío o no es válido
            if (!rut || rut.trim() === "") {
                //console.log("El RUT no puede estar vacío.");
                return;
            }

            // Realizar la solicitud al backend
            axios.get(this.urlBase + '/buscarPersona/' + rut)
                .then((response) => {
                    console.log("Respuesta del servidor:", response.data);
                    if (response.data.success) {
                        // Almacenar el valor de personaEncontrada
                        this.personaEncontrada = response.data.personaEncontrada;

                        if (this.personaEncontrada) {
                            //console.log("Persona encontrada:", this.personaEncontrada);
                        } else {
                            //console.log("Persona encontrada:", this.personaEncontrada);
                        }
                    } else {
                        console.error("Error al procesar la solicitud:", response.data.message);
                    }
                })
                .catch((error) => {
                    console.error("Error en la solicitud Axios:", error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error en la búsqueda',
                        text: 'Ocurrió un error al buscar la persona. Inténtelo nuevamente más tarde.'
                    });
                });
    },

    findEmailExist(email, tipo, index = null) {
    // Verificar si el email está vacío o solo contiene espacios en blanco
    if (!email || email.trim() === "") {
        return;
    }

    // Realizar la petición al backend para verificar el correo y RUT
    axios.get(this.urlBase + '/buscarEmail/' + email)
        .then((response) => {
            console.log('Respuesta del servidor:', response.data);

            // Variables provenientes del backend
            const totalRuts = response.data.totalRuts || 0; // Total de RUTs asociados
            const rutsByEmail = response.data.rutsAsociados?.split(',').map(rut => rut.toUpperCase().trim()) || [];
            let normalizedRut = "";

            // Determinar el RUT según el tipo
            if (tipo === 'representanteCchc') {
                normalizedRut = this.dataRepresentante.rutRepre?.toUpperCase().trim();
            } else if (tipo === 'contactoCobranza') {
                normalizedRut = this.dataContactoCobranza.rutContactoCob?.toUpperCase().trim();
            } else if (tipo === 'representanteLegal') {
                normalizedRut = this.form.rutRepreLegal[index]?.toUpperCase().trim();
            }

            console.log("Total de RUTs asociados:", totalRuts);
            console.log("RUTs asociados al email:", rutsByEmail);
            console.log("RUT ingresado:", normalizedRut);

            // Caso 1: El RUT está registrado pero el correo no coincide (o no existe)
            if (this.personaEncontrada && (totalRuts === 0 || !rutsByEmail.includes(normalizedRut))) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Correo asociado al RUT no coincide, póngase en contacto con el área socios al correo areasocios@cchc.cl'
                });

                // Limpiar el campo de email según el tipo
                if (tipo === 'representanteCchc') {
                    this.dataRepresentante.emailRepre = "";
                } else if (tipo === 'contactoCobranza') {
                    this.dataContactoCobranza.emailContacto = "";
                } else if (tipo === 'representanteLegal') {
                    this.$set(this.form.emailRereLegal, index, "");
                }
                return;
            }

            // Caso 2: El correo está registrado pero no se ingresó un RUT válido
            if (!this.personaEncontrada && totalRuts > 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'El correo electrónico ya existe en nuestros registros. Por favor, ingrese uno diferente.'
                });

                // Limpiar el campo de email según el tipo
                if (tipo === 'representanteCchc') {
                    this.dataRepresentante.emailRepre = "";
                } else if (tipo === 'contactoCobranza') {
                    this.dataContactoCobranza.emailContacto = "";
                } else if (tipo === 'representanteLegal') {
                    this.$set(this.form.emailRereLegal, index, "");
                }
                return;
            }

            // Caso 3: El correo no está registrado en absoluto
            if (totalRuts === 0) {
                console.log("El correo no está registrado en el sistema.");
                return;
            }
        })
        .catch((error) => {
            console.log("Error de Axios: ", error);
            Swal.fire({
                icon: 'error',
                title: 'Error al verificar el correo electrónico.',
                text: 'Por favor, inténtelo de nuevo más tarde.'
            });
        });
},

// Método adicional para limpiar el campo de email según el tipo
clearEmail(tipo, index) {
    if (tipo === 'representanteCchc') {
        this.dataRepresentante.emailRepre = "";
    } else if (tipo === 'contactoCobranza') {
        this.dataContactoCobranza.emailContacto = "";
    } else if (tipo === 'representanteLegal') {
        this.form.emailRereLegal[index] = "";
    }
},

sameMailValidation(emailField) {
    // Lista de representantes con sus correos y RUTs
    const allEmails = [
        { email: this.dataRepresentante.emailRepre, rut: this.dataRepresentante.rutRepre, field: 'dataRepresentante.emailRepre' },
        { email: this.dataContactoCobranza.emailContacto, rut: this.dataContactoCobranza.rutContactoCob, field: 'dataContactoCobranza.emailContacto' },
        ...this.form.emailRereLegal.map((email, index) => ({
            email,
            rut: this.form.rutRepreLegal[index],
            field: `form.emailRereLegal[${index}]`,
            index,
        })),
    ];

    // Validar correos duplicados con RUTs diferentes
    for (let i = 0; i < allEmails.length; i++) {
        const current = allEmails[i];

        // Saltar si el email actual está vacío
        if (!current.email) continue;

        for (let j = i + 1; j < allEmails.length; j++) {
            const compare = allEmails[j];

            // Comparar correos y verificar si los RUTs son diferentes
            if (current.email === compare.email && current.rut !== compare.rut) {
                this.$swal({
                    icon: 'warning',
                    title: 'Debe ingresar un correo electrónico diferente para los representantes',
                });

                // Determinar qué campo limpiar basado en emailField
                if (emailField === current.field) {
                    this.clearField(current);
                } else if (emailField === compare.field) {
                    this.clearField(compare);
                }
                return; // Terminar después de encontrar un conflicto
            }
        }
    }
},

// Función auxiliar para limpiar un campo
clearField(field) {
    if (field.index !== undefined) {
        // Limpiar campo en Representante Legal
        this.$set(this.form.emailRereLegal, field.index, '');
        console.log("tiene que limpiar el mail repre legal");
        if (this.$refs[`emailRepreLeg2_${field.index}`]) {
            this.$refs[`emailRepreLeg2_${field.index}`].focus();
            this.$set(this.form.emailRereLegal, field.index, '');
        }
    } else {
        // Limpiar campo en Representante o Contacto
        if (field.field === 'dataRepresentante.emailRepre') {
            this.dataRepresentante.emailRepre = '';
        } else if (field.field === 'dataContactoCobranza.emailContacto') {
            this.dataContactoCobranza.emailContacto = '';
        }
    }
},



    //seccion carga

    loadRepresentanteCchc(tipo, index) {
      //console.log(index, "holarepre");
      if (tipo == 1) {
        console.log("verifica todo",this.$refs.cargoContacto);  // Verifica si existe
        console.log("verifica todo2",this.$refs.generoContacto);
        if (
          //this.dataRepresentante.declaracion = true &&
          this.dataRepresentante.rutRepre != "" &&
          this.dataRepresentante.nombreRepre != "" &&
          this.dataRepresentante.apellidoRepre != "" &&
          this.dataRepresentante.apellidoRepre2 != "" &&
          // this.dataRepresentante.telRepre != "" &&
          this.dataRepresentante.celRepre != "" &&
          this.dataRepresentante.emailRepre != "" &&
          this.dataRepresentante.area != "" &&
          this.dataRepresentante.cargo != "" &&
          this.dataRepresentante.genero != ""
        ) {
          this.validation.contacto.area = true;
          this.validation.contacto.cargo = true;
          this.validation.contacto.sexo = true;
          this.validation.repre.area = true;
          this.validation.repre.cargo = true;
          this.validation.repre.sexo = true;
          // validaciones de campos del CChC , se valida rut correo celular y telefono (opcional)
          if (!this.validarCamposCChC()) {
            return;
          }

          this.$refs.rutContacto.className = "input active";
          this.dataContactoCobranza.rutContactoCob = this.dataRepresentante.rutRepre;
          this.$refs.rutContacto.value = this.dataRepresentante.rutRepre;
          this.$store.commit(
            "rutContactoCobIsValidation",
            this.dataContactoCobranza.rutContactoCob
          );

          this.$refs.nombreContacto.className = "input active";
          this.dataContactoCobranza.nombreContactoCob = this.dataRepresentante.nombreRepre;
          this.$refs.nombreContacto.value = this.dataRepresentante.nombreRepre;

          this.$refs.apellidoContacto.className = "input active";
          this.dataContactoCobranza.apellidoContacto = this.dataRepresentante.apellidoRepre;
          this.$refs.apellidoContacto.value = this.dataRepresentante.apellidoRepre;

          this.$refs.apellidoMaContacto.className = "input active";
          this.dataContactoCobranza.apellidoMatContacto = this.dataRepresentante.apellidoRepre2;
          this.$refs.apellidoMaContacto.value = this.dataRepresentante.apellidoRepre2;
          if (
            this.dataRepresentante.telRepre != "" ||
            this.dataRepresentante.telRepre != "+56"
          ) {
            this.$refs.telContacto.className = "input active";
            this.dataContactoCobranza.telContacto = this.dataRepresentante.telRepre;
            this.$refs.telContacto.value = this.dataRepresentante.telRepre;
            this.$store.commit(
              "telContactoCobIsValidation",
              this.dataContactoCobranza.telContacto
            );
          }

          this.$refs.celContacto.className = "input active";
          this.dataContactoCobranza.celContacto = this.dataRepresentante.celRepre;
          this.$refs.celContacto.value = this.dataRepresentante.celRepre;
          this.$store.commit(
            "celContactoCobIsValidation",
            this.dataContactoCobranza.celContacto
          );

          this.$refs.emailContacto.className = "input active";
          this.dataContactoCobranza.emailContacto = this.dataRepresentante.emailRepre;
          this.$refs.emailContacto.value = this.dataRepresentante.emailRepre;
          this.$store.commit(
            "emailContactoCobIsValidation",
            this.dataContactoCobranza.emailContacto
          );

          this.$refs.areaContacto.className = "input active";
          this.dataContactoCobranza.areaContacto = this.dataRepresentante.area;
          //this.$refs.areaContacto.value = this.dataRepresentante.area;
          this.$store.commit(
            "AreaContactoCobranzaValidationIndex",
            this.dataContactoCobranza.areaContacto
          );
          this.$store.commit("setAreaContactoCob", this.dataContactoCobranza.areaContacto);
          this.$store.dispatch("getCargosCob");

          this.$refs.cargoContacto.className = "input active";
          this.dataContactoCobranza.cargoContacto = this.dataRepresentante.cargo;
          this.$refs.cargoContacto.value = this.dataRepresentante.cargo;
          console.log("refs",this.$refs);
          this.$store.commit(
            "CargoRepreLegalValidationIndex",
            this.dataContactoCobranza.cargoContacto
          );

          this.$refs.generoContacto.className = "input active";
          this.dataContactoCobranza.generoContacto = this.dataRepresentante.genero;
          this.$refs.generoContacto.value = this.dataRepresentante.genero;
          this.$store.commit(
            "SexoValidationIndex",
            this.dataContactoCobranza.generoContacto
          );
          this.validation.contacto.area = true;
          this.validation.contacto.cargo = true;
          this.validation.contacto.sexo = true;
          this.validation.repre.area = true;
          this.validation.repre.cargo = true;
          this.validation.repre.sexo = true;
        } else {
          this.camposIncompletosCchc = [];
          /* if (this.dataRepresentante.declaracion == false) {
            this.camposIncompletosCchc.push("declaracion");
          } */
          if (this.dataRepresentante.rutRepre == "") {
            this.camposIncompletosCchc.push("rut");
          }
          if (this.dataRepresentante.nombreRepre == "") {
            this.camposIncompletosCchc.push("nombre");
          }
          if (this.dataRepresentante.apellidoRepre == "") {
            this.camposIncompletosCchc.push("apellido paterno");
          }
          if (this.dataRepresentante.apellidoRepre2 == "") {
            this.camposIncompletosCchc.push("apellido materno");
          }
          if (
            this.dataRepresentante.celRepre == "" ||
            this.dataRepresentante.celRepre == "+56"
          ) {
            this.camposIncompletosCchc.push("número de celular");
          }
          if (this.dataRepresentante.emailRepre == "") {
            this.camposIncompletosCchc.push("correo");
          }
          if (this.dataRepresentante.area == "") {
            this.camposIncompletosCchc.push("area");
          }
          if (this.dataRepresentante.cargoRepre == "") {
            this.camposIncompletosCchc.push("cargo");
          }
          if (this.dataRepresentante.genero == "") {
            this.camposIncompletosCchc.push("genero");
          }

          Swal.fire({
            icon: "warning",
            title: `Se debe completar la información del ${this.camposIncompletosCchc.join(
              ", "
            )} del representante ante la CChC.`,
          });
        }
      }
      const flag = index;
      if (tipo == 2) {
        // seccion representante legal

        if (
          /* this.dataRepresentante.declaracion == true && */
          this.dataRepresentante.rutRepre != "" &&
          this.dataRepresentante.nombreRepre != "" &&
          this.dataRepresentante.apellidoRepre != "" &&
          this.dataRepresentante.apellidoRepre2 != "" &&
          // this.dataRepresentante.telRepre != "" &&
          this.dataRepresentante.celRepre != "" &&
          this.dataRepresentante.emailRepre != "" &&
          this.dataRepresentante.area != "" &&
          this.dataRepresentante.cargo != "" &&
          this.dataRepresentante.genero != ""
        ) {
          //console.log("RUT FORM primero", this.form.rutRepreLegal);
          if (this.form.rutRepreLegal.length > 0) {
            //  const foundRepresentante = this.form.rutRepreLegal.indexOf(this.dataRepresentante.rutRepre.toLowerCase())
            let foundRepresentante = -1;
            this.form.rutRepreLegal.forEach((elemnt, i) => {
              if (
                elemnt.toLowerCase() ==
                  this.dataRepresentante.rutRepre.toLowerCase() &&
                foundRepresentante == -1
              ) {
                foundRepresentante = i;
              }
            });
            //console.log("foundRepresentante", foundRepresentante);
            if (foundRepresentante >= 0 && foundRepresentante != flag) {
              // alerta
              Swal.fire({
                icon: "warning",
                title:
                  "El rut del representante ante la CChC ya se encuentra ingresado como representante legal",
              });
              this.limpiarCamposRepresentante(flag);
              return;
            }
          }

          // validaciones de campos del CChC , se valida rut correo celular y telefono (opcional)
          if (!this.validarCamposCChC()) {
            return;
          }

          this.$refs.rutRepre2[index].className = "input active";
          this.form.rutRepreLegal[
            index
          ] = this.dataRepresentante.rutRepre.toLowerCase();
          this.$refs.rutRepreLeg2[
            index
          ].value = this.dataRepresentante.rutRepre.toLowerCase();
          this.$store.commit(
            "rutRepreLegalIsValidation",
            this.form.rutRepreLegal[index]
          );

          this.$refs.nombreRepre2[index].className = "input active";
          this.$refs.nombreRepreLeg2[
            index
          ].value = this.dataRepresentante.nombreRepre;
          this.form.nomRepreLegal[index] = this.dataRepresentante.nombreRepre;

          this.$refs.apePatRepre2[index].className = "input active";
          this.$refs.apePatRepreLeg2[
            index
          ].value = this.dataRepresentante.apellidoRepre;
          this.form.apePatRepreLegal[
            index
          ] = this.dataRepresentante.apellidoRepre;

          this.$refs.apeMatRepre2[index].className = "input active";
          this.$refs.apeMatRepreLeg2[
            index
          ].value = this.dataRepresentante.apellidoRepre2;
          this.form.apeMatReprelegal[
            index
          ] = this.dataRepresentante.apellidoRepre2;

          if (
            this.dataRepresentante.telRepre != "" ||
            this.dataRepresentante.telRepre != "+56"
          ) {
            this.$refs.telRepre2[index].className = "input active";
            this.$refs.telRepreLeg2[
              index
            ].value = this.dataRepresentante.telRepre;
            this.form.telRepreLegal[index] = this.dataRepresentante.telRepre;
            this.$store.commit(
              "telRepreLegalIsValidation",
              this.form.telRepreLegal[index]
            );
          }

          this.$refs.celRepre2[index].className = "input active";
          this.$refs.celRepreLeg2[
            index
          ].value = this.dataRepresentante.celRepre;
          this.form.celRepreLegal[index] = this.dataRepresentante.celRepre;
          this.$store.commit(
            "celRepreLegalIsValidation",
            this.form.celRepreLegal[index]
          );

          this.$refs.emailRepre2[index].className = "input active";
          this.$refs.emailRepreLeg2[
            index
          ].value = this.dataRepresentante.emailRepre;
          this.form.emailRereLegal[index] = this.dataRepresentante.emailRepre;
          this.$store.commit(
            "emailRepreLegalIsValidation",
            this.form.emailRereLegal[index]
          );

          this.$refs.areaRepre2[index].className = "input active";
          this.$refs.areaRepre2[index].value = this.dataRepresentante.area;
          this.form.area[index] = this.dataRepresentante.area;
          this.$store.commit(
            "CargoRepreLegalValidationIndex",
            this.form.area[index]
          );

          this.$store.commit("setAreaRepreLegal",  this.form.area[index]);
          this.$store.dispatch("getCargosRepreLegal");

          this.$refs.cargoRepre2[index].className = "input active";
          this.$refs.cargoRepre2[index].value = this.dataRepresentante.cargo;
          this.form.cargo[index] = this.dataRepresentante.cargo;
          this.$store.commit(
            "CargoRepreLegalValidationIndex",
            this.form.cargo[index]
          );

          /*this.$refs.cargoInput.className = "input active";
          this.$refs.cargoInput.value = this.dataRepresentante.cargo;
          this.form.cargo[index] = this.dataRepresentante.cargo;
          this.$store.commit(
            "CargoInputValidationIndex",
            this.dataRepresentante.cargo
          );

         /* this.$refs.cargoRepre2.className = "input active";
          this.$refs.cargoRepre2.value = this.dataRepresentante.cargo;
          this.form.cargoRepre2[index] = this.dataRepresentante.cargo;
          this.$store.commit(
            "CargoContactoValidationIndex",
            this.dataRepresentante.cargoRepre2
          );*/
          //this.$refs.generoRepreLeg2[index].className = "input active";
          this.$refs.generoRepreLeg2[
            index
          ].value = this.dataRepresentante.genero;
          this.form.gender[index] = this.dataRepresentante.genero;
          this.$store.commit(
            "SexoValidationIndexRepreLeg2",
            this.form.gender[index]
          );
          this.validation.contacto.area = true;
          this.validation.contacto.cargo = true;
          this.validation.contacto.sexo = true;
          this.validation.repre.area = true;
          this.validation.repre.cargo = true;
          this.validation.repre.sexo = true;
        } else {
          this.camposIncompletosCchc = [];
          /* if (this.dataRepresentante.declaracion == false) {
            this.camposIncompletosCchc.push("declaracion");
          } */
          if (this.dataRepresentante.rutRepre == "") {
            this.camposIncompletosCchc.push("rut");
          }
          if (this.dataRepresentante.nombreRepre == "") {
            this.camposIncompletosCchc.push("nombre");
          }
          if (this.dataRepresentante.apellidoRepre == "") {
            this.camposIncompletosCchc.push("apellido paterno");
          }
          if (this.dataRepresentante.apellidoRepre2 == "") {
            this.camposIncompletosCchc.push("apellido materno");
          }
          if (
            this.dataRepresentante.celRepre == "" ||
            this.dataRepresentante.celRepre == "+56"
          ) {
            this.camposIncompletosCchc.push("número de celular");
          }
          if (this.dataRepresentante.emailRepre == "") {
            this.camposIncompletosCchc.push("correo");
          }
          if (this.dataRepresentante.cargo == "") {
            this.camposIncompletosCchc.push("cargo");
          }
          if (this.dataRepresentante.genero == "") {
            this.camposIncompletosCchc.push("genero");
          }

          Swal.fire({
            icon: "warning",
            title: `Se debe completar la información del ${this.camposIncompletosCchc.join(
              ", "
            )} del representante ante la CChC.`,
          });
        }
      }
    },

    validarCamposCChC() {
      if (
        !this.rutRepresentanteCChCIsValid ||
        (!this.telRepresentanteCChCIsValid &&
          this.telRepresentanteCChCIsValid !== "") ||
        !this.celRepresentanteCChCIsValid ||
        !this.emailRepresentanteCChCIsValid
      ) {
        this.camposInvalidosCchc = [];

        if (this.rutRepresentanteCChCIsValid == false) {
          this.camposInvalidosCchc.push("rut");
        }
        if (
          !this.telRepresentanteCChCIsValid &&
          this.telRepresentanteCChCIsValid !== ""
        ) {
          this.camposInvalidosCchc.push("número de teléfono fijo");
        }
        if (this.celRepresentanteCChCIsValid == false) {
          this.camposInvalidosCchc.push("número de celular");
        }
        if (this.emailRepresentanteCChCIsValid == false) {
          this.camposInvalidosCchc.push("correo");
        }
        Swal.fire({
          icon: "warning",
          title: `La información del ${this.camposInvalidosCchc.join(
            ", "
          )} del representante ante la CChC debe ser válida.`,
        });
        return false;
      } else {
        return true;
      }
    },
    CargoValidation() {
      if (this.cargo == "") {
        this.CargoIsValid = false;
      } else {
        this.CargoIsValid = true;
      }
    },

    CargoContactoValidation() {
      if (this.cargoContacto == "") {
        this.CargoContactoIsValid = false;
      } else {
        this.CargoContactoIsValid = true;
      }
    },

    CargoRepreLegalValidation(state) {
      if (this.cargoRepreLegal == "") {
        this.CargoRepreIsValid = false;
      } else {
        this.CargoRepreIsValid = true;
      }
    },

    declaracionValidation() {
      if (this.dataRepresentante) {
        this.declaracionIsValid = this.dataRepresentante.declaracion;
      } else {
        this.declaracionIsValid = false;
      }
    },

    loadContactoCobranza(index) {
      if (
        this.dataContactoCobranza.rutContactoCob != "" &&
        this.dataContactoCobranza.nombreContactoCob != "" &&
        this.dataContactoCobranza.apellidoContacto != "" &&
        this.dataContactoCobranza.apellidoMatContacto != "" &&
        // this.dataContactoCobranza.telContacto != "" &&
        this.dataContactoCobranza.celContacto != "" &&
        this.dataContactoCobranza.emailContacto != "" &&
        this.dataContactoCobranza.areaContacto != "" &&
        this.dataContactoCobranza.cargoContacto != "" &&
        this.dataContactoCobranza.generoContacto != ""
      ) {
        if (this.form.rutRepreLegal.length > 0) {
          // const foundRepresentante = this.form.rutRepreLegal.indexOf(this.dataContactoCobranza.rutContactoCob.toLowerCase())
          let foundRepresentante = -1;
          this.form.rutRepreLegal.forEach((elemnt, i) => {
            if (
              elemnt.toLowerCase() ==
                this.dataContactoCobranza.rutContactoCob.toLowerCase() &&
              foundRepresentante == -1
            ) {
              foundRepresentante = i;
            }
          });
          if (foundRepresentante >= 0 && foundRepresentante != index) {
            // alerta
            Swal.fire({
              icon: "warning",
              title:
                "El rut del contacto de cobranza ya se encuentra ingresado como representante legal",
            });
            this.limpiarCamposRepresentante(index);

            return;
          }
        }

        // validaciones de campos del contacto de cobranza, se valida rut correo celular y telefono (opcional)
        if (!this.validarCamposCobranza()) {
          return;
        }

        if (
          this.rutPatrocinanteGlobal[0].rut1.toLowerCase() ==
            this.dataContactoCobranza.rutContactoCob.toLowerCase() ||
          this.rutPatrocinanteGlobal[0].rut2.toLowerCase() ==
            this.dataContactoCobranza.rutContactoCob.toLowerCase()
        ) {
          Swal.fire({
            icon: "warning",
            title: "El Rut no puede ser el de un patrocinante",
          });
          return;
        }

        // separador
        this.$refs.rutRepre2[index].className = "input active";
        this.$refs.rutRepreLeg2[
          index
        ].value = this.dataContactoCobranza.rutContactoCob.toLowerCase();
        this.form.rutRepreLegal[
          index
        ] = this.dataContactoCobranza.rutContactoCob.toLowerCase();

        this.$store.commit(
          "rutRepreLegalIsValidation",
          this.form.rutRepreLegal[index]
        );
        // separador
        this.$refs.nombreRepre2[index].className = "input active";
        this.$refs.nombreRepreLeg2[
          index
        ].value = this.dataContactoCobranza.nombreContactoCob;
        this.form.nomRepreLegal[
          index
        ] = this.dataContactoCobranza.nombreContactoCob;
        // separador
        this.$refs.apePatRepre2[index].className = "input active";
        this.$refs.apePatRepreLeg2[
          index
        ].value = this.dataContactoCobranza.apellidoContacto;
        this.form.apePatRepreLegal[
          index
        ] = this.dataContactoCobranza.apellidoContacto;
        // separador
        this.$refs.apeMatRepre2[index].className = "input active";
        this.$refs.apeMatRepreLeg2[
          index
        ].value = this.dataContactoCobranza.apellidoMatContacto;
        this.form.apeMatReprelegal[
          index
        ] = this.dataContactoCobranza.apellidoMatContacto;
        // separador
        if (
          this.dataContactoCobranza.telContacto != "" ||
          this.dataContactoCobranza.telContacto != "+56"
        ) {
          this.$refs.telRepre2[index].className = "input active";
          this.$refs.telRepreLeg2[
            index
          ].value = this.dataContactoCobranza.telContacto;
          this.form.telRepreLegal[
            index
          ] = this.dataContactoCobranza.telContacto;
          this.$store.commit(
            "telRepreLegalIsValidation",
            this.form.telRepreLegal[index]
          );
        }
        // separador
        this.$refs.celRepre2[index].className = "input active";
        this.$refs.celRepreLeg2[
          index
        ].value = this.dataContactoCobranza.celContacto;
        this.form.celRepreLegal[index] = this.dataContactoCobranza.celContacto;
        this.$store.commit(
          "celRepreLegalIsValidation",
          this.form.celRepreLegal[index]
        );
        // separador
        this.$refs.emailRepre2[index].className = "input active";
        this.$refs.emailRepreLeg2[
          index
        ].value = this.dataContactoCobranza.emailContacto;
        this.form.emailRereLegal[
          index
        ] = this.dataContactoCobranza.emailContacto;
        this.$store.commit(
          "emailRepreLegalIsValidation",
          this.form.emailRereLegal[index]
        );


        this.$refs.areaInput[
          index
        ].value = this.dataContactoCobranza.areaContacto;
        this.form.area[index] = this.dataContactoCobranza.areaContacto;
        this.$store.commit(
          "AreaRepreLegalValidationIndex",
          this.form.area[index]
        );


        //console.log("ultimooooooo", this.form, this.$refs);
        // this.$refs.cargoRepre[index].className = "input active";
        this.$refs.cargoRepre2[
          index
        ].value = this.dataContactoCobranza.cargoContacto;
        this.form.cargo[index] = this.dataContactoCobranza.cargoContacto;
        this.$store.commit(
          "CargoRepreLegalValidationIndex",
          this.form.cargo[index]
        );

        // this.$refs.generoRepre[index].className = "input active";
        this.$refs.generoRepreLeg2[
          index
        ].value = this.dataContactoCobranza.generoContacto;
        this.form.gender[index] = this.dataContactoCobranza.generoContacto;
        this.$store.commit(
          "SexoValidationIndexContacto",
          this.form.gender[index]
        );
        this.validation.contacto.area = true;
        this.validation.contacto.cargo = true;
        this.validation.contacto.sexo = true;
        this.validation.repre.area = true;
        this.validation.repre.cargo = true;
        this.validation.repre.sexo = true;
      } else {
        this.camposIncompletosCobranza = [];

        if (this.dataContactoCobranza.rutContactoCob == "") {
          this.camposIncompletosCobranza.push("rut");
        }
        if (this.dataContactoCobranza.nombreContactoCob == "") {
          this.camposIncompletosCobranza.push("nombre");
        }
        if (this.dataContactoCobranza.apellidoContacto == "") {
          this.camposIncompletosCobranza.push("apellido paterno");
        }
        if (this.dataContactoCobranza.apellidoMatContacto == "") {
          this.camposIncompletosCobranza.push("apellido materno");
        }
        if (
          this.dataContactoCobranza.celContacto == "" ||
          this.dataContactoCobranza.celContacto == "+56"
        ) {
          this.camposIncompletosCobranza.push("número de celular");
        }

        if (this.dataContactoCobranza.emailContacto == "") {
          this.camposIncompletosCobranza.push("correo");
        }
        if (this.dataContactoCobranza.cargoContacto == "") {
          this.camposIncompletosCobranza.push("cargo");
        }
        if (this.dataContactoCobranza.generoContacto == "") {
          this.camposIncompletosCobranza.push("genero");
        }

        Swal.fire({
          icon: "warning",
          title: `Se debe completar la información del ${this.camposIncompletosCobranza.join(
            ", "
          )} del contacto de Cobranza.`,
        });
      }
    },

    validarCamposCobranza() {
      if (
        !this.rutContactoCobIsValid ||
        (!this.telContactoCobIsValid && this.telContactoCobIsValid !== "") ||
        !this.celContactoCobIsValid ||
        !this.emailContactoCobIsValid
      ) {
        this.camposInvalidosCobranza = [];
        if (!this.rutContactoCobIsValid) {
          this.camposInvalidosCobranza.push("rut");
        }
        if (!this.telContactoCobIsValid && this.telContactoCobIsValid !== "") {
          this.camposInvalidosCobranza.push("número de teléfono fijo");
        }
        if (!this.celContactoCobIsValid) {
          this.camposInvalidosCobranza.push("número de celular");
        }
        if (!this.emailContactoCobIsValid) {
          this.camposInvalidosCobranza.push("correo");
        }

        Swal.fire({
          icon: "warning",
          title: `La información del ${this.camposInvalidosCobranza.join(
            ", "
          )} del contacto de Cobranza debe ser válida.`,
        });

        return false;
      } else {
        return true;
      }
    },

    limpiarCamposRepresentante(index) {
      this.$refs.rutRepreLeg2[index].value = "";
      this.form.rutRepreLegal[index] = "";

      this.$refs.nombreRepreLeg2[index].value = "";
      this.form.nomRepreLegal[index] = "";

      this.$refs.apePatRepreLeg2[index].value = "";
      this.form.apePatRepreLegal[index];

      this.$refs.apeMatRepreLeg2[index].value = "";
      this.form.apeMatReprelegal[index] = "";

      this.$refs.telRepreLeg2[index].value = "";
      this.form.telRepreLegal[index] = "";

      this.$refs.celRepreLeg2[index].value = "";
      this.form.celRepreLegal[index] = "";

      this.$refs.emailRepreLeg2[index].value = "";
      this.form.emailRereLegal[index] = "";

      this.$refs.cargoRepreLeg2[index].value = "";
      this.form.cargoRepre2[index];

      this.$refs.generoRepreLeg2[index].value = "";
      this.form.generoRepre[index];
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    save() {
      Swal.fire({
        title: "¿Está seguro que desea guardar su postulación?",
        //text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "btn btn-danger",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.data = [{}];
          console.log("contacto de dataContactoCobranza",this.dataContactoCobranza.areaContacto);
          //console.log("declaracion antes de guardar", this.dataRepresentante);
          this.data.push({
            //Data form representante
            dataRepresentante: {
              declaracion: this.dataRepresentante.declaracion,
              rutRepre: this.dataRepresentante.rutRepre,
              nombreRepre: this.dataRepresentante.nombreRepre,
              apellidoRepre: this.dataRepresentante.apellidoRepre,
              apellidoRepre2: this.dataRepresentante.apellidoRepre2,
              telRepre: this.dataRepresentante.telRepre,
              celRepre: this.dataRepresentante.celRepre,
              emailRepre: this.dataRepresentante.emailRepre,
              //date: this.dataRepresentante.date
              area: this.dataRepresentante.area,
              cargo: this.dataRepresentante.cargo,
              genero: this.dataRepresentante.genero,
              //declaracion: this.declaracion,
            },

            //Data form contacto de cobranza
            dataContactoCobranza: {
              rutContactoCob: this.dataContactoCobranza.rutContactoCob,
              nombreContactoCob: this.dataContactoCobranza.nombreContactoCob,
              apellidoContacto: this.dataContactoCobranza.apellidoContacto,
              apellidoMatContacto: this.dataContactoCobranza.apellidoMatContacto,
              telContacto: this.dataContactoCobranza.telContacto,
              celContacto: this.dataContactoCobranza.celContacto,
              emailContacto: this.dataContactoCobranza.emailContacto,
              areaContacto: this.dataContactoCobranza.areaContacto,
              cargoContacto: this.dataContactoCobranza.cargoContacto,
              generoContacto: this.dataContactoCobranza.generoContacto,
            },
            //Data Representante Legal
            dataRepreLegal: {
              datosRepreAdd: this.form,
            },

            //Data form comites
            dataComites: {
              contratista: this.dataComites.contratista,
              obras: this.dataComites.obras,
              concesiones: this.dataComites.concesiones,
              inmobiliario: this.dataComites.inmobiliario,
              vivienda: this.dataComites.vivienda,
              proveedores: this.dataComites.proveedores,
              industriales: this.dataComites.industriales,
              especialidades: this.dataComites.especialidades,
            },
          });
          //console.log("data completo", this.data);
          this.saveCompletedForm([this.data[1], 4]);
          this.savePostStepFour();
          //this.dataRepresentante = this.dataRepresentante;
          Swal.fire("¡Datos guardados satisfactoriamente!", "", "success");
        }
      });
    },

    saveContinueStepFour() {
      if (this.corregir) {
        if (
          this.rutRepresentanteCChCIsValid == true &&
          //  (this.telRepresentanteCChCIsValid == true ||
          //  this.telRepresentanteCChCIsValid === "") &&
          //  this.celRepresentanteCChCIsValid == true &&
          this.emailRepresentanteCChCIsValid == true &&
          this.rutContactoCobIsValid == true &&
          /* (this.telContactoCobIsValid == true ||
            this.telContactoCobIsValid === "") &&*/
          //  this.celContactoCobIsValid == true &&
          this.emailContactoCobIsValid == true &&
          this.rutRepreLegalIsValid == true &&
          /* (this.telRepreLegalIsValid == true ||
            this.telRepreLegalIsValid === "") &&*/
          //  this.celRepreLegalIsValid == true &&
          this.emailRepreLegalIsValid == true &&
          this.cargoRepreLegalIsValid == true &&
          this.validateRepresentanteLegalForm()
        ) {
          let telefonoRepresentante = "";
          if (
            this.dataRepresentante.telRepre != "" &&
            this.dataRepresentante.telRepre != "+56"
          ) {
            telefonoRepresentante = this.dataRepresentante.telRepre;
          }

          let telefonoCobranza = "";
          if (
            this.dataContactoCobranza.telContacto != "" &&
            this.dataContactoCobranza.telContacto != "+56"
          ) {
            telefonoCobranza = this.dataRepresentante.telRepre;
          }
          this.data.push({
            //Data form representante
            dataRepresentante: {
              declaracion: this.dataRepresentante.declaracion,
              rutRepre: this.dataRepresentante.rutRepre,
              nombreRepre: this.dataRepresentante.nombreRepre,
              apellidoRepre: this.dataRepresentante.apellidoRepre,
              apellidoRepre2: this.dataRepresentante.apellidoRepre2,
              telRepre: telefonoRepresentante,
              // telRepre: this.dataRepresentante.telRepre,
              celRepre: this.dataRepresentante.celRepre,
              emailRepre: this.dataRepresentante.emailRepre,
              //date: this.dataRepresentante.date
              area: this.dataRepresentante.area,
              cargo: this.dataRepresentante.cargo,
              genero: this.dataRepresentante.genero,
            },

            //Data form contacto de cobranza
            dataContactoCobranza: {
              rutContactoCob: this.dataContactoCobranza.rutContactoCob,
              nombreContactoCob: this.dataContactoCobranza.nombreContactoCob,
              apellidoContacto: this.dataContactoCobranza.apellidoContacto,
              apellidoMatContacto: this.dataContactoCobranza
                .apellidoMatContacto,
              telContacto: telefonoCobranza,
              // telContacto: this.dataContactoCobranza.telContacto,
              celContacto: this.dataContactoCobranza.celContacto,
              emailContacto: this.dataContactoCobranza.emailContacto,
              areaContacto: this.dataContactoCobranza.areaContacto,
              cargoContacto: this.dataContactoCobranza.cargoContacto,
              generoContacto: this.dataContactoCobranza.generoContacto,
            },

            //Data Representante Legal
            dataRepreLegal: {
              datosRepreAdd: this.form,
            },

            //Data form comites
            dataComites: {
              contratista: this.dataComites.contratista,
              obras: this.dataComites.obras,
              concesiones: this.dataComites.concesiones,
              inmobiliario: this.dataComites.inmobiliario,
              vivienda: this.dataComites.vivienda,
              proveedores: this.dataComites.proveedores,
              industriales: this.dataComites.industriales,
              especialidades: this.dataComites.especialidades,
            },
          });
          //console.log("data 1");
          //console.log(this.data[1]);
          this.saveCompletedForm([this.data[1], 4]);
          if (!this.tieneCorreccion) {
            console.log("NO TIENE CORRECCION AQUI", this.tieneCorreccion);
            this.saveStepFour();
          } else {
            console.log("TIENE CORRECCION - NO SE GUARDA EN BASE", this.tieneCorreccion);
          }
        } else {
          // alert("Tiene que ingresar datos válidos");
          Swal.fire({
            icon: "warning",
            title: "Tiene que ingresar datos válidos",
          });
        }
      } else {
        this.data.push({
          //Data form representante
          dataRepresentante: {
            declaracion: this.dataRepresentante.declaracion,
            rutRepre: this.dataRepresentante.rutRepre,
            nombreRepre: this.dataRepresentante.nombreRepre,
            apellidoRepre: this.dataRepresentante.apellidoRepre,
            apellidoRepre2: this.dataRepresentante.apellidoRepre2,
            telRepre: this.dataRepresentante.telRepre,
            celRepre: this.dataRepresentante.celRepre,
            emailRepre: this.dataRepresentante.emailRepre,
            area: this.dataRepresentante.area,
            cargo: this.dataRepresentante.cargo,
            genero: this.dataRepresentante.genero,
            //date: this.dataRepresentante.date
          },

          //Data form contacto de cobranza
          dataContactoCobranza: {
            rutContactoCob: this.dataContactoCobranza.rutContactoCob,
            nombreContactoCob: this.dataContactoCobranza.nombreContactoCob,
            apellidoContacto: this.dataContactoCobranza.apellidoContacto,
            apellidoMatContacto: this.dataContactoCobranza.apellidoMatContacto,
            telContacto: this.dataContactoCobranza.telContacto,
            celContacto: this.dataContactoCobranza.celContacto,
            emailContacto: this.dataContactoCobranza.emailContacto,
            areaContacto: this.dataContactoCobranza.areaContacto,
            cargoContacto: this.dataContactoCobranza.cargoContacto,
            generoContacto: this.dataContactoCobranza.generoContacto,
          },

          //Data Representante Legal
          dataRepreLegal: {
            datosRepreAdd: this.form,
          },

          //Data form comites
          dataComites: {
            contratista: this.dataComites.contratista,
            obras: this.dataComites.obras,
            concesiones: this.dataComites.concesiones,
            inmobiliario: this.dataComites.inmobiliario,
            vivienda: this.dataComites.vivienda,
            proveedores: this.dataComites.proveedores,
            industriales: this.dataComites.industriales,
            especialidades: this.dataComites.especialidades,
          },
        });
        //console.log("soy el data", this.data);
        this.saveCompletedForm([this.data[1], 4]);
        /* this.saveStepFour(); */
      }
    },
    validateRepresentantesCCHCRut() {
      const rut = this.dataRepresentante.rutRepre;
      if (
        this.rutPatrocinanteGlobal[0].rut1 !== rut &&
        this.rutPatrocinanteGlobal[0].rut2 !== rut
      ) {
        return true;
      } else {
        return false;
      }
    },
    validateRepresentantesLegalesRut() {
      // //console.log('representante',this.form.rutRepreLegal);
      const findFirstRut = this.form.rutRepreLegal.indexOf(
        this.rutPatrocinanteGlobal[0].rut1.toLowerCase()
      );
      const findSecondRut = this.form.rutRepreLegal.indexOf(
        this.rutPatrocinanteGlobal[0].rut2.toLowerCase()
      );

      if (findFirstRut >= 0 || findSecondRut >= 0) {
        if (findFirstRut >= 0) {
          this.posicionRepresentante = findFirstRut;
        }
        if (findSecondRut >= 0) {
          this.posicionRepresentante = findSecondRut;
        }
        return false;
      } else {
        return true;
      }
    },

    saveContinue() {
      if (this.corregir) {
        console.log("aqui estoy1");
        if (this.validateInput() && this.validateRepresentanteLegalForm()) {
          console.log("aqui estoy2");
          if (this.validateRepresentantesCCHCRut()) {
            if (this.validateRepresentantesLegalesRut()) {
              this.saveContinueStepFour();
              this.setStepFiveValue(true);

              this.setStepFourValue(false);

              /* if(this.declaracionIsValid == ""){
                Swal.fire({
                icon: "warning",
                title: "Debe confirmar que ha leído y aceptado las condiciones de postulación.",
              });
              this.declaracionIsValid == false;
              } */

            } else {
              Swal.fire({
                icon: "warning",
                title: `El representante legal N° ${this.posicionRepresentante +
                  1} no puede ser un patrocinante.`,
              });
            }
          } else {
            Swal.fire({
              icon: "warning",
              title: "El representante CChC no puede ser un patrocinante.",
            });
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Debe ingresar todos los campos",
          });
          this.setStepFiveValue(false);
          this.CargoValidation();
          //this.dataRepresentante.declaracion = false;
          this.declaracionValidation();
        }
      } else {
        this.saveContinueStepFour();
        this.setStepFiveValue(true);
        this.setStepFourValue(false);
      }
    },
    validateRepresentanteLegalForm() {
  const longRut = this.form.rutRepreLegal.length;
  const longNom = this.form.nomRepreLegal.length;
  const longPat = this.form.apePatRepreLegal.length;
  const longMat = this.form.apeMatReprelegal.length;
  const longTel = this.form.telRepreLegal.length;
  const longCel = this.form.celRepreLegal.length;
  const longEmail = this.form.emailRereLegal.length;
  const longCargo = this.form.cargo.length;
  const longGenero = this.form.gender.length;
  const longArea = this.form.area.length;

  const rutLegalIsValid = !this.form.rutRepreLegal.includes("");
  const nombreLegalIsValid = !this.form.nomRepreLegal.includes("");
  const apellidoPatLegalIsValid = !this.form.apePatRepreLegal.includes("");
  const apellidoMatLegalIsValid = !this.form.apeMatReprelegal.includes("");
  const telLegalIsValid = !this.form.telRepreLegal.includes("");
  const celLegalIsValid = !this.form.celRepreLegal.includes("");
  const telLegalIsValid56 = this.form.telRepreLegal.some(tel => tel.startsWith("+56"));
  const celLegalIsValid56 = this.form.celRepreLegal.some(cel => cel.startsWith("+56"));
  const emailLegalIsValid = !this.form.emailRereLegal.includes("");
  const areaLegalIsValid = !this.form.area.includes("");
  const cargoLegalIsValid = !this.form.cargo.includes("");
  const generoLegalIsValid = !this.form.gender.includes("");

  // Verificar que las longitudes de todos los campos sean iguales
  if (
    longRut === longNom &&
    longNom === longPat &&
    longPat === longMat &&
    longMat === longTel &&
    longTel === longCel &&
    longCel === longEmail &&
    longEmail === longCargo &&
    longCargo === longGenero &&
    longGenero === longArea
  ) {
    // Verificar que ninguno de los campos esté vacío
    if (
      rutLegalIsValid &&
      nombreLegalIsValid &&
      apellidoPatLegalIsValid &&
      apellidoMatLegalIsValid &&
      telLegalIsValid &&
      celLegalIsValid &&
      emailLegalIsValid &&
      areaLegalIsValid &&
      cargoLegalIsValid &&
      generoLegalIsValid &&
      telLegalIsValid56 &&
      celLegalIsValid56
    ) {
      if (this.validation.latest.element === 0) {
        this.validation.repre.cargo = true;
        this.validation.repre.sexo = true;
      }
      return true;
    } else {
      if (!areaLegalIsValid) {
        this.validation.repre.area = false;
      }
      if (!cargoLegalIsValid) {
        this.validation.repre.cargo = false;
      }
      if (!generoLegalIsValid) {
        this.validation.repre.sexo = false;
      }
      return false;
    }
  } else {
    if (!celLegalIsValid56) {
      this.$store.commit("celRepreLegalIsValidation", "+56");
    }
    return false;
  }
},

    anterior() {
      //this.$router.push({ name: "StepTree" });
      this.setStepThreeValue(true);
      this.setStepFourValue(false);
    },

    show(modalName) {
      this.$modal.show(modalName);
    },

    hide(modalName) {
      this.$modal.hide(modalName);
    },

    addInput(ultimoElemento) {
      if (this.corregir) {
        //console.log("ultimoElemento", ultimoElemento);
        if (ultimoElemento > 0) {
          //console.log("ultimoElemento", ultimoElemento);
          this.validation.latest.element = ultimoElemento;
          if (this.validateRepresentanteLegalForm()) {
            if (
              this.inputs[ultimoElemento].rutRepreLegal[ultimoElemento] &&
              this.inputs[ultimoElemento].nomRepreLegal[ultimoElemento] &&
              this.inputs[ultimoElemento].apePatRepreLegal[ultimoElemento] &&
              this.inputs[ultimoElemento].apeMatReprelegal[ultimoElemento] &&
              // this.inputs[ultimoElemento].telRepreLegal[ultimoElemento]  &&
              this.inputs[ultimoElemento].celRepreLegal[ultimoElemento] &&
              this.inputs[ultimoElemento].emailRereLegal[ultimoElemento] &&
              this.inputs[ultimoElemento].area[ultimoElemento] &&
              this.inputs[ultimoElemento].cargo[ultimoElemento] &&
              this.inputs[ultimoElemento].gender[ultimoElemento] &&
              this.telRepreLegalIsValid &&
              this.celRepreLegalIsValid &&
              this.rutRepreLegalIsValid &&
              this.emailRepreLegalIsValid &&
              this.cargoRepreLegalIsValid &&
              this.sexoIsvalidateRepreLeg2
            ) {
              this.inputs.push(this.form);
              this.inputs[this.inputs.length - 1].telRepreLegal[
                this.inputs.length - 1
              ] = "+56";
              // this.$store.commit('telRepreLegalIsValidation', '+56')
              this.inputs[this.inputs.length - 1].celRepreLegal[
                this.inputs.length - 1
              ] = "+56";
              // this.$store.commit('celRepreLegalIsValidation', '+56')
            } else {
              //alert('Debe ingresar todos los campos del Representante Legal, antes de poder añadir uno nuevo');
              Swal.fire({
                icon: "warning",
                title:
                  "Debe ingresar todos los campos del Representante Legal, antes de poder añadir uno nuevo",
              });
            }
          } else {
            //alert('Debe ingresar todos los campos del Representante Legal, antes de poder añadir uno nuevo');
            Swal.fire({
              icon: "warning",
              title:
                "Debe ingresar todos los campos del Representante Legal, antes de poder añadir uno nuevo",
            });
          }
        } else {
          if (this.validateRepresentanteLegalForm()) {
            ////console.log("entra aqui en el segundo if");

            this.inputs.push(this.form);
            this.inputs[this.inputs.length - 1].telRepreLegal[
              this.inputs.length - 1
            ] = "+56";
            this.inputs[this.inputs.length - 1].celRepreLegal[
              this.inputs.length - 1
            ] = "+56";
          } else {
            //alert('Debe ingresar todos los campos del Representante Legal, antes de poder añadir uno nuevo');
            Swal.fire({
              icon: "warning",
              title:
                "Debe ingresar todos los campos del Representante Legal, antes de poder añadir uno nuevo",
            });
          }
        }
      } else {
        Swal.fire({
          icon: "warning",
          title: "Opción no disponible para corrección",
        });
      }
    },
    addDinamicInput() {
      this.inputs.push(this.form);
    },

    deleteSocio(ultimoElemento, i) {
      if (this.corregir) {
        Swal.fire({
          title: "¿Está seguro de eliminar este representante?",
          //text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire("Eliminado satisfactoriamente!", "", "success");
            ////console.log('inputs',this.inputs);
            ////console.log('inputs',this.inputs.length);
            this.inputs[ultimoElemento].rutRepreLegal.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].rutRepreLegal);
            this.inputs[ultimoElemento].nomRepreLegal.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].nomRepreLegal);
            this.inputs[ultimoElemento].apePatRepreLegal.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].apePatRepreLegal);
            this.inputs[ultimoElemento].apeMatReprelegal.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].apeMatReprelegal);
            this.inputs[ultimoElemento].telRepreLegal.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].telRepreLegal);
            this.inputs[ultimoElemento].celRepreLegal.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].celRepreLegal);
            this.inputs[ultimoElemento].emailRereLegal.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].emailRereLegal);
            this.inputs.splice(i, 1);
            this.inputs[ultimoElemento].area.splice(i, 1);
            
            this.inputs[ultimoElemento].cargo.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].emailRereLegal);
            this.inputs.splice(i, 1);
            this.inputs[ultimoElemento].gender.splice(i, 1);
            ////console.log(this.inputs[ultimoElemento].emailRereLegal);
            this.inputs.splice(i, 1);

            this.updateValidations();

            ////console.log('inputs delete',this.inputs);
          }
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Opción no disponible para corrección",
        });
      }
    },
    updateValidations() {
      // recorremos cada elemento para resetear los estados de las validaciones
      this.form.rutRepreLegal.forEach((elemento) => {
        this.$store.commit("rutRepreLegalIsValidation", elemento);
      });
      this.form.telRepreLegal.forEach((elemento) => {
        this.$store.commit("telRepreLegalIsValidation", elemento);
      });
      this.form.celRepreLegal.forEach((elemento) => {
        this.$store.commit("celRepreLegalIsValidation", elemento);
      });
      this.form.emailRereLegal.forEach((elemento) => {
        this.$store.commit("emailRepreLegalIsValidation", elemento);
      });
      this.form.area.forEach((elemento) => {
        this.$store.commit("AreaRepreLegalValidationIndex", elemento);
      });
      this.form.cargo.forEach((elemento) => {
        this.$store.commit("CargoRepreLegalValidationIndex", elemento);
      });
      this.form.gender.forEach((elemento) => {
        this.$store.commit("SexoValidationIndex", elemento);
      });
    },

    contAddInput() {
      this.contador = this.contador + 1;
      this.total = this.total + this.contador;
    },

    validateInput() {
      if (this.dataRepresentante.area.length === 0 || this.dataRepresentante.area == "") {
        console.log("entro en la validacion de area vacia");
        this.validation.area = false;
      }
      if (this.dataRepresentante.cargo == "") {
        this.validation.cargo = false;
      }
      /* if (this.dataRepresentante.area == "") {
        this.validation.repre.area = true;
      } */
     
      if (this.dataRepresentante.genero == "") {
        this.validation.sexo = false;
      }

      if (this.dataContactoCobranza.generoContacto == "") {
        this.validation.contacto.sexo = false;
      }

      if (this.dataContactoCobranza.areaContacto == "") {
        this.validation.contacto.area = false;
      }

      if (this.dataContactoCobranza.cargoContacto == "") {
        this.validation.contacto.cargo = false;
      }

      if (
        //this.declaracionIsValid == true &&
        //this.declaracionIsValid !== "" &&
        this.dataRepresentante.nombreRepre !== "" &&
        this.dataRepresentante.apellidoRepre !== "" &&
        this.dataRepresentante.apellidoRepre2 !== "" &&
        this.dataRepresentante.declaracion == true &&
        this.dataRepresentante.rutRepre !== "" &&
        // && ((this.dataRepresentante.telRepre !== '') || )
        this.dataRepresentante.celRepre !== "" &&
        this.dataRepresentante.emailRepre !== "" &&
        this.dataRepresentante.area !== "" &&
        this.dataRepresentante.area.length !== 0 &&
        this.dataRepresentante.cargo !== "" &&
        this.dataRepresentante.genero !== "" &&
        this.dataContactoCobranza.rutContactoCob !== "" &&
        this.dataContactoCobranza.nombreContactoCob !== "" &&
        this.dataContactoCobranza.apellidoContacto !== "" &&
        this.dataContactoCobranza.apellidoMatContacto !== "" &&
        // && this.dataContactoCobranza.telContacto !== ''
        this.dataContactoCobranza.celContacto !== "" &&
        this.dataContactoCobranza.emailContacto !== "" &&
        this.dataContactoCobranza.areaContacto.length !== 0 &&
        this.dataContactoCobranza.cargoContacto !== "" &&
        this.dataContactoCobranza.generoContacto !== ""
      ) {
        /*if (
          this.rutRepresentanteCChCIsValid == true &&
          (this.telRepresentanteCChCIsValid == true ||
            this.telRepresentanteCChCIsValid === "") &&
          this.celRepresentanteCChCIsValid == true &&
          this.emailRepresentanteCChCIsValid == true &&
          this.rutContactoCobIsValid == true &&
          (this.telContactoCobIsValid == true ||
            this.telContactoCobIsValid === "") &&
          this.celContactoCobIsValid == true &&
          this.emailContactoCobIsValid == true &&
          this.rutRepreLegalIsValid == true &&
          (this.telRepreLegalIsValid == true ||
            this.telRepreLegalIsValid === "") &&
          this.celRepreLegalIsValid == true &&
          this.emailRepreLegalIsValid == true &&
          this.cargoRepreLegalIsValid == true &&
          this.sexoIsvalidate == true
        ) {
          return true;
        } else {
          return false;
        }*/
       console.log("te tengo1");
        return true;
      } else {
        console.log("te tengo2");
        return false;
       
      }
    },

    validateRutRepresentanteCchcExist(
      rut,
      refsNom,
      refsApe,
      refsApe2,
      refsRut,
      nombreInput,
      apellidoInput,
      apellidoInput2
    ) {
      // //console.log('rutPatrocinanteGlobal',this.rutPatrocinanteGlobal)
      if (this.rutPatrocinanteGlobal.length > 0) {
        if (
          this.rutPatrocinanteGlobal[0].rut1.toLowerCase() !==
            rut.toLowerCase() &&
          this.rutPatrocinanteGlobal[0].rut2.toLowerCase() !== rut.toLowerCase()
        ) {
          const rutString = new String(rut);

          axios
            .get(this.urlBase + "/validarRepresentantes/" + rutString)
            .then((response) => {
              this.dataValidaciones = response.data;

              if (Object.keys(this.dataValidaciones).length !== 0) {
                if (this.dataValidaciones[0].ESTADO == "1") {
                  this.dataRepresentante.nombreRepre = this.dataValidaciones[0].NOMBRE;
                  this.dataRepresentante.apellidoRepre = this.dataValidaciones[0].APELLIDO_PAT;
                  this.dataRepresentante.apellidoRepre2 = this.dataValidaciones[0].APELLIDO_MAT;
                  nombreInput.value = this.dataValidaciones[0].NOMBRE;
                  apellidoInput.value = this.dataValidaciones[0].APELLIDO_PAT;
                  apellidoInput2.value = this.dataValidaciones[0].APELLIDO_MAT;

                  this.focus(refsNom);
                  this.focus(refsApe);
                  this.focus(refsApe2);
                  //this.representanteLegalActivo = true
                } else {
                  //this.representanteLegalActivo = false
                  // alert("El Representante tiene que estar activo");
                  //   refsRut.value = "";
                  // refsNom.value = "";
                  // refsApe.value = "";
                  // refsApe2.value = "";
                  // this.dataRepresentante.nombreRepre = "";
                  // this.dataRepresentante.apellidoRepre = "";
                  // this.dataRepresentante.apellidoRepre2 = "";
                  // this.dataRepresentante.rutRepre = "";
                  //   Swal.fire({
                  //     icon: 'warning',
                  //     title: 'El Representante tiene que estar activo',
                  // })
                }
              }
              // solo se controla si existe para rellenar los campos y ver si esta activo
              // else {
              //   refsRut.value = "";
              //   refsNom.value = "";
              //   refsApe.value = "";
              //   refsApe2.value = "";
              //   this.dataRepresentante.nombreRepre = "";
              //   this.dataRepresentante.apellidoRepre = "";
              //   this.dataRepresentante.apellidoRepre2 = "";
              //   this.dataRepresentante.rutRepre = "";
              //   Swal.fire({
              //       icon: 'warning',
              //       title: 'No existe ningun representante asociado a ese Rut',
              //   })
              // }
            })
            .catch(function(error) {
              //console.log("AXIOS ERROR: ", error);
            });
        } else {
          // alert("El Rut no puede ser el de un patrocinante");
          Swal.fire({
            icon: "warning",
            title: "El Rut no puede ser el de un patrocinante",
          });
          this.dataRepresentante.rutRepre = "";
          this.dataRepresentante.nombreRepre = "";
          this.dataRepresentante.apellidoRepre = "";
          this.dataRepresentante.apellidoRepre2 = "";
        }
      } else {
        // alert("Debe ingresar los RUT de los patrocinantes del paso anterior");
        Swal.fire({
          icon: "warning",
          title: "Debe ingresar los RUT de los patrocinantes del paso anterior",
        });
        this.dataRepresentante.rutRepre = "";
        this.dataRepresentante.nombreRepre = "";
        this.dataRepresentante.apellidoRepre = "";
        this.dataRepresentante.apellidoRepre2 = "";
      }
    },

    validateRutContactoCobranzaExist(rut, refsNom, refsApe, refsApe2) {
      const rutString = new String(rut);
      axios
        .get(this.urlBase + "/validarRepresentantes/" + rutString)
        .then((response) => {
          this.dataValidaciones = response.data;

          if (Object.keys(this.dataValidaciones).length !== 0) {
            if (this.dataValidaciones[0].ESTADO == "1") {
              this.dataContactoCobranza.nombreContactoCob = this.dataValidaciones[0].NOMBRE;
              this.dataContactoCobranza.apellidoContacto = this.dataValidaciones[0].APELLIDO_PAT;
              this.dataContactoCobranza.apellidoMatContacto = this.dataValidaciones[0].APELLIDO_MAT;

              this.focus(refsNom);
              this.focus(refsApe);
              this.focus(refsApe2);
            } else {
              // alert("El Representante tiene que estar activo");
              //   Swal.fire({
              //     icon: 'warning',
              //     title: 'El Representante tiene que estar activo',
              // })
            }
          } else {
            // this.dataContactoCobranza.nombreContactoCob = "";
            // this.dataContactoCobranza.apellidoContacto= "";
            // this.dataContactoCobranza.apellidoMatContacto = "";
          }
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    validateRutRepresentanteLegalFormExist(
      rut,
      index,
      refsNom,
      refsApe,
      refsApe2,
      nombreInput,
      apellidoPatInput,
      apellidoMatInput,
      refsRut
    ) {
      if (this.rutPatrocinanteGlobal.length > 0) {
        if (
          this.rutPatrocinanteGlobal[0].rut1.toLowerCase() !==
            rut.toLowerCase() &&
          this.rutPatrocinanteGlobal[0].rut2.toLowerCase() !== rut.toLowerCase()
        ) {
          const rutString = new String(rut);
          axios
            .get(this.urlBase + "/validarRepresentantes/" + rutString)
            .then((response) => {
              this.dataValidaciones = response.data;

              if (Object.keys(this.dataValidaciones).length !== 0) {
                if (this.dataValidaciones[0].ESTADO == "1") {
                  // const findRepresentanteLegal = this.form.rutRepreLegal.indexOf(rut.toLowerCase())
                  let findRepresentanteLegal = -1;
                  let cont = 0;
                  this.form.rutRepreLegal.forEach((elemnt, i) => {
                    if (
                      elemnt.toLowerCase() == rut.toLowerCase() &&
                      findRepresentanteLegal == -1
                    ) {
                      findRepresentanteLegal = i;
                    }
                    if (elemnt.toLowerCase() == rut.toLowerCase()) {
                      // puede darse que haya mas de 1 en el array entonces contamos
                      cont++;
                    }
                  });

                  if (
                    findRepresentanteLegal >= 0 &&
                    findRepresentanteLegal != index
                  ) {
                    this.form.rutRepreLegal[index] = "";
                    this.form.nomRepreLegal[index] = "";
                    this.form.apePatRepreLegal[index] = "";
                    this.form.apeMatReprelegal[index] = "";
                    refsRut.value = "";
                    nombreInput.value = "";
                    apellidoPatInput.value = "";
                    apellidoMatInput.value = "";
                    this.$refs.telRepreLeg2[index].value = "";
                    this.form.telRepreLegal[index] = "";

                    this.$refs.celRepreLeg2[index].value = "";
                    this.form.celRepreLegal[index] = "";

                    this.$refs.emailRepreLeg2[index].value = "";
                    this.form.emailRereLegal[index] = "";

                    this.$refs.cargoRepreLeg2[index].value = "";
                    this.form.cargoRepre2[index] = "";

                    this.$refs.generoRepreLeg2[index].value = "";
                    this.form.generoRepre[index] = "";

                    Swal.fire({
                      icon: "warning",
                      title:
                        "El rut ya se encuentra ingresado como representante legal",
                    });
                    return false;
                  } else {
                    if (cont > 1 && findRepresentanteLegal == index) {
                      // puede haber mas de uno
                      this.form.rutRepreLegal[index] = "";
                      this.form.nomRepreLegal[index] = "";
                      this.form.apePatRepreLegal[index] = "";
                      this.form.apeMatReprelegal[index] = "";
                      refsRut.value = "";
                      nombreInput.value = "";
                      apellidoPatInput.value = "";
                      apellidoMatInput.value = "";
                      this.$refs.telRepreLeg2[index].value = "";
                      this.form.telRepreLegal[index] = "";

                      this.$refs.celRepreLeg2[index].value = "";
                      this.form.celRepreLegal[index] = "";

                      this.$refs.emailRepreLeg2[index].value = "";
                      this.form.emailRereLegal[index] = "";

                      this.$refs.cargoRepreLega2[index].value = "";
                      this.form.cargo[index] = "";

                      //this.$refs.generoRepreLeg2[index].value = "";
                      //this.form.gender[index] = "";

                      Swal.fire({
                        icon: "warning",
                        title:
                          "El rut ya se encuentra ingresado como representante legal",
                      });
                      return false;
                    } else {
                      this.form.nomRepreLegal[
                        index
                      ] = this.dataValidaciones[0].NOMBRE;
                      this.form.apePatRepreLegal[
                        index
                      ] = this.dataValidaciones[0].APELLIDO_PAT;
                      this.form.apeMatReprelegal[
                        index
                      ] = this.dataValidaciones[0].APELLIDO_MAT;
                      nombreInput.value = this.dataValidaciones[0].NOMBRE;
                      apellidoPatInput.value = this.dataValidaciones[0].APELLIDO_PAT;
                      apellidoMatInput.value = this.dataValidaciones[0].APELLIDO_MAT;

                      this.focus(refsNom);
                      this.focus(refsApe);
                      this.focus(refsApe2);
                      // //console.log(refsNom);
                      return true;
                    }
                  }
                } else {
                  // alert("El Representante tiene que estar activo");
                  // Swal.fire({
                  //   icon: 'warning',
                  //   title: 'El Representante tiene que estar activo',
                  // })
                }
              }
              // const findRepresentanteLegal = this.form.rutRepreLegal.indexOf(rut.toLowerCase())

              let findRepresentanteLegal = -1;
              let cont = 0;
              this.form.rutRepreLegal.forEach((elemnt, i) => {
                if (
                  elemnt.toLowerCase() == rut.toLowerCase() &&
                  findRepresentanteLegal == -1
                ) {
                  findRepresentanteLegal = i;
                }
                if (elemnt.toLowerCase() == rut.toLowerCase()) {
                  // puede darse que haya mas de 1 en el array entonces contamos
                  cont++;
                }
              });
              if (
                findRepresentanteLegal >= 0 &&
                findRepresentanteLegal != index
              ) {
                this.form.rutRepreLegal[index] = "";
                this.form.nomRepreLegal[index] = "";
                this.form.apePatRepreLegal[index] = "";
                this.form.apeMatReprelegal[index] = "";
                refsRut.value = "";
                nombreInput.value = "";
                apellidoPatInput.value = "";
                apellidoMatInput.value = "";
                this.$refs.telRepreLeg2[index].value = "";
                this.form.telRepreLegal[index] = "";

                this.$refs.celRepreLeg2[index].value = "";
                this.form.celRepreLegal[index] = "";

                this.$refs.emailRepreLeg2[index].value = "";
                this.form.emailRereLegal[index] = "";

                this.$refs.cargoRepreLeg2[index].value = "";
                this.form.cargoRepre2[index] = "";

                this.$refs.generoRepreLeg2[index].value = "";
                this.form.generoRepre[index] = "";
                Swal.fire({
                  icon: "warning",
                  title:
                    "El rut ya se encuentra ingresado como representante legal",
                });
                return false;
              } else {
                if (cont > 1 && findRepresentanteLegal == index) {
                  this.form.rutRepreLegal[index] = "";
                  this.form.nomRepreLegal[index] = "";
                  this.form.apePatRepreLegal[index] = "";
                  this.form.apeMatReprelegal[index] = "";
                  refsRut.value = "";
                  nombreInput.value = "";
                  apellidoPatInput.value = "";
                  apellidoMatInput.value = "";
                  this.$refs.telRepreLeg2[index].value = "";
                  this.form.telRepreLegal[index] = "";

                  this.$refs.celRepreLeg2[index].value = "";
                  this.form.celRepreLegal[index] = "";

                  this.$refs.emailRepreLeg2[index].value = "";
                  this.form.emailRereLegal[index] = "";

                  this.$refs.cargoRepreLeg2[index].value = "";
                  this.form.cargoRepre2[index] = "";

                  this.$refs.generoRepreLeg2[index].value = "";
                  this.form.generoRepre[index] = "";
                  Swal.fire({
                    icon: "warning",
                    title:
                      "El rut ya se encuentra ingresado como representante legal",
                  });
                  return false;
                }
              }
            })
            .catch(function(error) {
              //console.log("AXIOS ERROR: ", error);
            });
        } else {
          this.form.rutRepreLegal[index] = "";
          this.form.nomRepreLegal[index] = "";
          this.form.apePatRepreLegal[index] = "";
          this.form.apeMatReprelegal[index] = "";
          refsRut.value = "";
          nombreInput.value = "";
          apellidoPatInput.value = "";
          apellidoMatInput.value = "";
          this.$refs.telRepreLeg2[index].value = "";
          this.form.telRepreLegal[index] = "";

          this.$refs.celRepreLeg2[index].value = "";
          this.form.celRepreLegal[index] = "";

          this.$refs.emailRepreLeg2[index].value = "";
          this.form.emailRereLegal[index] = "";

          this.$refs.cargoRepreLeg2[index].value = "";
          this.form.cargoRepre2[index] = "";

          this.$refs.generoRepreLeg2[index].value = "";
          this.form.generoRepre[index] = "";
          //alert("El Rut no puede ser el de un patrocinante");
          Swal.fire({
            icon: "warning",
            title: "El Rut no puede ser el de un patrocinante",
          });
          return false;
        }
      } else {
        // alert("Debe ingresar los RUT de los patrocinantes del paso anterior");
        Swal.fire({
          icon: "warning",
          title: "Debe ingresar los RUT de los patrocinantes del paso anterior",
        });
        this.form.rutRepreLegal[index] = "";
      }
    },

    savePostStepFour: function() {
      let objPatrocinante = this.completedForm;
      let data = JSON.stringify(objPatrocinante);
      if (this.completedForm.length > 0) {
        axios
          .post(this.urlBase + "/guardarParcial", data)
          .then((response) => {
            //console.log(response.data);
            Swal.fire("¡Datos guardados satisfactoriamente!", "", "success");
          })
          .catch(function(error) {});
      } else {
        //alert("¡Error al guardar, intente de nuevo!");
        Swal.fire({
          icon: "warning",
          title: "¡Error al guardar, intente de nuevo!",
        });
      }
    },
    saveStepFour: function() {
      let objPatrocinante = this.completedForm;
      //console.log(JSON.stringify(objPatrocinante));
      let data = JSON.stringify(objPatrocinante);
      if (this.completedForm.length > 0) {
        axios
          .post(this.urlBase + "/guardarParcial", data)
          .then((response) => {
            //console.log(response.data);
            // Swal.fire("¡Datos guardados satisfactoriamente!", "", "success");
          })
          .catch(function(error) {});
      } else {
        //alert("¡Error al guardar, intente de nuevo!");
        Swal.fire({
          icon: "warning",
          title: "¡Error al guardar, intente de nuevo!",
        });
      }
    },
    cleanInput(index) {
      if (this.dataRepresentante.rutRepre == "") {
        this.dataRepresentante.nombreRepre = "";
        this.dataRepresentante.apellidoRepre = "";
        this.dataRepresentante.apellidoRepre2 = "";
      }

      if (this.dataContactoCobranza.rutContactoCob == "") {
        this.dataContactoCobranza.nombreContactoCob = "";
        this.dataContactoCobranza.apellidoContacto = "";
        this.dataContactoCobranza.apellidoMatContacto = "";
      }

      if (this.form.rutRepreLegal[index] == "") {
        this.form.nomRepreLegal[index] = "";
        this.form.apePatRepreLegal[index] = "";
        this.form.apeMatReprelegal[index] = "";
      }
    },
    // traemos el objeto de nuevo
    getRut() {
      console.log("entra en el getRut del paso4")
      //console.log("estopy en create", this.$route.params);
      let routeNumber = this.$route.params.id;
      let number;
      let rut;
      axios
        .get(this.URL + "/getRut/" + routeNumber)
        .then((response) => {
          let data = response.data;
          number = data[0].requestNumber;
          rut = data[0].rut;
          if (routeNumber == number) {
            this.getNroSolicitud(rut);
          } else {
          }
          ////console.log(this.tipoSocDocs);
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },
    getNroSolicitud(rut) {
      //console.log("de nuevo en el created", rut);
        console.log("entra en el getNroSolicitud del paso 4", rut);
      axios
        .get(this.urlBase + "/buscarPostulante/" + rut)
        .then((response) => {
          const datosBasicos = response.data;

          const nroSolicitud = datosBasicos[0].nro_solicitud;
          //this.nroSolicitudObj(this.nroSolicitud);

          this.validationStep(nroSolicitud);
          setTimeout(this.getStepThreeRequest(nroSolicitud), 1000);
          //this.getSocietyType(this.nroSolicitud);
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    // metodo que verifica la correccion del formulario
    validationStep(nroSolicitud) {
      // //console.log('Numero de SOLICITUD', nroSolicitud)
      console.log("entra en el validationStep del paso 4")
      axios
        .get(this.URL + "/validarCorreccion/" + nroSolicitud + "-3")
        .then((response) => {
          let data = response.data;
          //console.log("Response Validar Correccion", data);

          if (data.ESTADO !== "PENDIENTE A ENVÍO") {
            //CORREGIR_PASO viene true si se debe volver a ingresar informacion y false si no se debe corregir, es decir es valido
            this.corregir = data.CORREGIR_PASO;

            this.tieneCorreccion = true; // indica que tomara el camino de correccion
          }
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    getStepThreeRequest(number) {
      //console.log("numero del created", number);
      let requestNumber = number;
      axios
        .get(this.urlBase + "/paso1/" + requestNumber)
        .then((response) => {
          let stepOneSaved = response.data;
          this.formLoaded = true;
          if(stepOneSaved.length){
            if (stepOneSaved[0].object !== "") {
              this.getStepFour = JSON.parse(stepOneSaved[0].object);
              //console.log("soy todo el json", this.getStepFour);
              const estado = JSON.parse(stepOneSaved[0].estado);
              const idConecta = JSON.parse(stepOneSaved[0].idConecta); // nueva modificacion al back
              if ((estado === 1 && idConecta == null) || estado === 3) {
                // TRAEMOS LA VARIABLE GLOBAL CON EL OBJETO ALMACENADO
                this.storeObjectStepFour = this.$store.getters.getterObjetoStepFour;
                // //console.log('STORE// objetoStepFour: ', this.storeObjectStepFour);
                if (this.storeObjectStepFour.length == 1) {
                  // this.$store.commit('setObjetoStepFour',this.getStepFour);
                  this.recoveryDataForm(this.getStepFour);
                } else {
                  this.recoveryDataForm(this.storeObjectStepFour);
                }
              }
              if (estado === 2 || estado === 0) {
              }
            } else {
              this.setAuth(false);
            }
          } 
          
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    recoveryDataForm(objectData) {
      /* DATOS DE stepFour
        dataComites: Object
        dataContactoCobranza: (...)
        dataRepreLegal: (...)
        dataRepresentante: (...)
      */
      const {
        dataComites,
        dataContactoCobranza,
        dataRepreLegal,
        dataRepresentante,
      } = objectData[4];
      console.log("voy por aca dataContactoCobranza", dataContactoCobranza);
      if (dataContactoCobranza && dataRepreLegal && dataRepresentante) {
        this.recoveryRepresentante(dataRepresentante);
        this.recoveryContactoCobranza(dataContactoCobranza);
        this.recoveryRepresentanteLegal(dataRepreLegal);
        this.recoveryComites(dataComites);
      } else {
        //console.log("No existe recuperacion parcial para StepFour");
      }
    },

    recoveryRepresentante(dataRepresentante) {
      //console.log("dataRepresentante", dataRepresentante);
      /*
        rutRepre: "9580141-2"
        nombreRepre: "Rosa"
        apellidoRepre: "Perez"
        apellidoRepre2: "Pereira"
        telRepre: "+56994169625"
        celRepre: "+56994169625"
        emailRepre: "kbasaure@isc.cl"
      */
      /* if (dataRepresentante.declaracion) {
        this.declaracion = dataRepresentante.declaracion;
      }
 */
        //console.log("rellenando declaracion", dataRepresentante.declaracion);
      if (dataRepresentante.declaracion) {
        ////console.log("rellenando declaracion", dataRepresentante.declaracion);
        this.dataRepresentante.declaracion = dataRepresentante.declaracion;
      }

      if (dataRepresentante.rutRepre) {
        this.$refs.rut.className = "input active";
        this.dataRepresentante.rutRepre = dataRepresentante.rutRepre.toLowerCase();
        this.$store.commit(
          "rutRepresentanteCChCIsValidation",
          this.dataRepresentante.rutRepre
        );
      }
      if (dataRepresentante.nombreRepre) {
        this.$refs.nombre.className = "input active";
        this.dataRepresentante.nombreRepre = dataRepresentante.nombreRepre;
      }
      if (dataRepresentante.apellidoRepre) {
        this.$refs.apellido.className = "input active";
        this.dataRepresentante.apellidoRepre = dataRepresentante.apellidoRepre;
      }
      if (dataRepresentante.apellidoRepre2) {
        this.$refs.apellido2.className = "input active";
        this.dataRepresentante.apellidoRepre2 =
          dataRepresentante.apellidoRepre2;
      }
      if (dataRepresentante.telRepre) {
        this.$refs.tel.className = "input active";
        this.dataRepresentante.telRepre = dataRepresentante.telRepre;
        this.$store.commit(
          "telRepresentanteCChCIsValidation",
          this.dataRepresentante.telRepre
        );
      }
      if (dataRepresentante.celRepre) {
        this.$refs.cel.className = "input active";
        this.dataRepresentante.celRepre = dataRepresentante.celRepre;
        this.$store.commit(
          "celRepresentanteCChCIsValidation",
          this.dataRepresentante.celRepre
        );
      }
      if (dataRepresentante.emailRepre) {
        this.$refs.email.className = "input active";
        this.dataRepresentante.emailRepre = dataRepresentante.emailRepre;
        this.$store.commit(
          "emailRepresentanteCChCIsValidation",
          this.dataRepresentante.emailRepre
        );
      }
      //modificar carga aqui
      if (dataRepresentante.area) {
        console.log("carga dataRepresentante", dataRepresentante.area);
        this.$refs.area.className = "input active";
        this.dataRepresentante.area = dataRepresentante.area;
       this.$store.commit(
          "AreaInputValidationIndex",
          this.dataRepresentante.area
        );
        this.$store.commit("setArea", dataRepresentante.area);
        this.$store.dispatch("getCargos");
      }

      if (dataRepresentante.cargo) {
        console.log("carga dataRepresentante.cargo", dataRepresentante.cargo);
        this.$refs.cargo.className = "input active";
        this.dataRepresentante.cargo = dataRepresentante.cargo;
        this.$store.commit(
          "CargoInputValidationIndex",
          this.dataRepresentante.cargo
        );
      }

      /* if (dataRepresentante.area && dataRepresentante.cargo){
        //cargamos el area
        this.$store.commit("setArea", dataRepresentante.area);
        this.dataRepresentante.area = dataRepresentante.area;
        console.log("carga dataRepresentante.cargo", dataRepresentante.cargo);
        console.log("carga dataRepresentante.area", dataRepresentante.area);
        //cargamos el cargo
        this.$store.commit("setCargo", dataRepresentante.cargo);
          this.selectedCargos = dataRepresentante.cargo;
          this.$store.dispatch("getCargos");
          this.dataRepresentantecargo = dataRepresentante.cargo;

      }
 */


      if (dataRepresentante.genero) {
        this.$refs.genero.className = "input active";
        this.dataRepresentante.genero = dataRepresentante.genero;
        this.$store.commit(
          "SexoValidationIndex",
          this.dataRepresentante.genero
        );
      }
    },

    recoveryContactoCobranza(dataContactoCobranza) {
      /*
        rutContactoCob: "17106515-1"
        nombreContactoCob: "Pedro"
        apellidoContacto: "Basaure"
        apellidoMatContacto: "Pereira"
        telContacto: "+56994169625"
        celContacto: "+56994169625"
        emailContacto: "kbasaure@isc.cl"
      */
      //console.log("voy por aca tambien", dataContactoCobranza);
      if (dataContactoCobranza.rutContactoCob) {
        this.$refs.rutContacto.className = "input active";
        this.dataContactoCobranza.rutContactoCob = dataContactoCobranza.rutContactoCob.toLowerCase();
        this.$store.commit(
          "rutContactoCobIsValidation",
          this.dataContactoCobranza.rutContactoCob
        );
      }
      if (dataContactoCobranza.nombreContactoCob) {
        this.$refs.nombreContacto.className = "input active";
        this.dataContactoCobranza.nombreContactoCob =
          dataContactoCobranza.nombreContactoCob;
      }
      if (dataContactoCobranza.apellidoContacto) {
        this.$refs.apellidoContacto.className = "input active";
        this.dataContactoCobranza.apellidoContacto =
          dataContactoCobranza.apellidoContacto;
      }
      if (dataContactoCobranza.apellidoMatContacto) {
        this.$refs.apellidoMaContacto.className = "input active";
        this.dataContactoCobranza.apellidoMatContacto =
          dataContactoCobranza.apellidoMatContacto;
      }
      if (dataContactoCobranza.telContacto) {
        this.$refs.telContacto.className = "input active";
        this.dataContactoCobranza.telContacto =
          dataContactoCobranza.telContacto;
        this.$store.commit(
          "telContactoCobIsValidation",
          this.dataContactoCobranza.telContacto
        );
      }
      if (dataContactoCobranza.celContacto) {
        this.$refs.celContacto.className = "input active";
        this.dataContactoCobranza.celContacto =
          dataContactoCobranza.celContacto;
        this.$store.commit(
          "celContactoCobIsValidation",
          this.dataContactoCobranza.celContacto
        );
      }
      if (dataContactoCobranza.emailContacto) {
        this.$refs.emailContacto.className = "input active";
        this.dataContactoCobranza.emailContacto =
          dataContactoCobranza.emailContacto;
        this.$store.commit(
          "emailContactoCobIsValidation",
          this.dataContactoCobranza.emailContacto
        );
      }
      /* if (dataContactoCobranza.areaContacto) {
        console.log("dataContactoCobranza.areaContacto",dataContactoCobranza.areaContacto);
        this.$refs.areaContacto.className = "input active";
        this.dataContactoCobranza.areaContacto =
          dataContactoCobranza.areaContacto;
        this.$store.commit(
          "CargoContactoValidationIndex",
          this.dataContactoCobranza.areaContacto
        );
      } */

       if (dataContactoCobranza.cargoContacto) {
        console.log("dataContactoCobranza.cargoContacto",dataContactoCobranza.cargoContacto);
        this.$refs.cargoContacto.className = "input active";
        this.dataContactoCobranza.cargoContacto =
          dataContactoCobranza.cargoContacto;
        this.$store.commit(
          "CargoContactoValidationIndex",
          this.dataContactoCobranza.cargoContacto
        );
      } 

      if (dataContactoCobranza.areaContacto) {
        console.log("carga dataContactoCobranza.areaContacto", dataContactoCobranza.areaContacto);
        this.$refs.area.className = "input active";
        this.dataContactoCobranza.areaContacto = dataContactoCobranza.areaContacto;
        this.$store.commit(
          "AreaInputValidationIndex",
          this.dataContactoCobranza.areaContacto
        );
        this.$store.commit("setAreaContactoCob", dataContactoCobranza.areaContacto);
        this.$store.dispatch("getCargosCob");
      }

      if (dataContactoCobranza.cargoContacto) {
        console.log("carga dataContactoCobranza.cargoContacto", dataContactoCobranza.cargoContacto);
        this.$refs.cargo.className = "input active";
        this.dataContactoCobranza.cargoContacto = dataContactoCobranza.cargoContacto;
        this.$store.commit(
          "AreaInputValidationIndex",
          this.dataContactoCobranza.cargoContacto
        );
      }

      if (dataContactoCobranza.generoContacto) {
        console.log("carga dataContactoCobranza.generoContacto", dataContactoCobranza);
        this.$refs.generoContacto.className = "input active";
        this.dataContactoCobranza.generoContacto =
          dataContactoCobranza.generoContacto;
        this.$store.commit(
          "SexoValidationIndexContacto",
          this.dataContactoCobranza.generoContacto
        );
      }
    },
    recoveryRepresentanteLegal(dataRepreLegal) {
      const representanteLegal = dataRepreLegal.datosRepreAdd;
      //console.log("representanteLegal cargo",representanteLegal.cargo);
      this.objectDataRepreLegal = representanteLegal;
      console.log("this.objectDataRepreLegal cargo",this.objectDataRepreLegal.cargo);
      /*
        datosRepreAdd: Object
          rutRepreLegal: Array(2)
          nomRepreLegal: Array(2)
          apePatRepreLegal: Array(2)
          apeMatReprelegal: Array(2)
          telRepreLegal: Array(2)
          celRepreLegal: Array(2)
          emailRereLegal: Array(2)
      */

      // vemos el tamaño para conocer los add que haremos

      const longitud = representanteLegal.rutRepreLegal.length;
      this.generateDinamicsForms(longitud);

      this.banderaActivarClases = false;
      representanteLegal.rutRepreLegal.forEach((element, index) => {
        if (element) {
          this.form.rutRepreLegal[index] = element.toLowerCase();
          this.$store.commit(
            "rutRepreLegalIsValidation",
            this.form.rutRepreLegal[index]
          );
        }
      });

      representanteLegal.nomRepreLegal.forEach((element, index) => {
        if (element) {
          this.form.nomRepreLegal[index] = element;
        }
      });

      representanteLegal.apePatRepreLegal.forEach((element, index) => {
        if (element) {
          this.form.apePatRepreLegal[index] = element;
        }
      });

      representanteLegal.apeMatReprelegal.forEach((element, index) => {
        if (element) {
          this.form.apeMatReprelegal[index] = element;
        }
      });

      representanteLegal.telRepreLegal.forEach((element, index) => {
        if (element) {
          this.form.telRepreLegal[index] = element;
          this.$store.commit(
            "telRepreLegalIsValidation",
            this.form.telRepreLegal[index]
          );
        }
      });

      representanteLegal.celRepreLegal.forEach((element, index) => {
        if (element) {
          this.form.celRepreLegal[index] = element;
          this.$store.commit(
            "celRepreLegalIsValidation",
            this.form.celRepreLegal[index]
          );
        }
      });

      representanteLegal.emailRereLegal.forEach((element, index) => {
        if (element) {
          this.form.emailRereLegal[index] = element;
          this.$store.commit(
            "emailRepreLegalIsValidation",
            this.form.emailRereLegal[index]
          );
        }
      });

      representanteLegal.area.forEach((element, index) => {
        if (element) {
          
          this.form.area[index] = element;
          console.log("carga representanteLegal.area", this.form.area[index]);
          this.$store.commit(
            "CargoRepreLegalValidationIndex",
            this.form.area[index]
          );
          this.$store.commit("setAreaRepreLegal", this.form.area[index]);
          this.$store.dispatch("getCargosRepreLegal");
        }
      });

      representanteLegal.cargo.forEach((element, index) => {
        if (element) {
          console.log("carga representanteLegal.cargo", this.form.cargo[index]);
          this.form.cargo[index] = element;
          this.$store.commit(
            "CargoRepreLegalValidationIndex",
            this.form.cargo[index]
          );
        }
      });
      representanteLegal.gender.forEach((element, index) => {
        if (element) {
          console.log("carga representanteLegal.gender", this.form.gender[index]);
          this.form.gender[index] = element;
          this.$store.commit("SexoValidationIndex", this.form.gender[index]);
        }
      });
      this.banderaActivarClases = true;
    },

    // metodo que añade formularios dinamicamente
    generateDinamicsForms(longitud) {
      for (let i = 0; i < longitud; i++) {
        if (i + 1 < longitud) {
          //this.addInput()
          this.addDinamicInput();
        }
      }
    },

    activateClassOffDinamicsForms() {
      const representanteLegal = this.objectDataRepreLegal;
      representanteLegal.rutRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.rutRepre2[index].className = "input active";
        }
      });

      representanteLegal.nomRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.nombreRepre2[index].className = "input active";
        }
      });

      representanteLegal.apePatRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.apePatRepre2[index].className = "input active";
        }
      });

      representanteLegal.apeMatReprelegal.forEach((element, index) => {
        if (element) {
          this.$refs.apeMatRepre2[index].className = "input active";
        }
      });

      representanteLegal.telRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.telRepre2[index].className = "input active";
        }
      });

      representanteLegal.celRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.celRepre2[index].className = "input active";
        }
      });

      representanteLegal.emailRereLegal.forEach((element, index) => {
        if (element) {
          this.$refs.emailRepre2[index].className = "input active";
        }
      });
      representanteLegal.area.forEach((element, index) => {
        if (element) {
          this.$refs.areaRepre2[index].className = "input active";
        }
      });
      representanteLegal.cargo.forEach((element, index) => {
        if (element) {
          this.$refs.cargoRepre2[index].className = "input active";
        }
      });
      representanteLegal.gender.forEach((element, index) => {
        if (element) {
          // this.$refs.generoRepre[index].className = "input-select";
        }
      });

      if (this.corregir === false) {
        this.deshabilitarCampos();
      } else {
      }
    },

    deshabilitarCampos() {
      const representanteLegal = this.objectDataRepreLegal;
      representanteLegal.rutRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.rutRepreLeg2[index].disabled = true;
        }
      });

      representanteLegal.nomRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.nombreRepreLeg2[index].disabled = true;
        }
      });

      representanteLegal.apePatRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.apePatRepreLeg2[index].disabled = true;
        }
      });

      representanteLegal.apeMatReprelegal.forEach((element, index) => {
        if (element) {
          this.$refs.apeMatRepreLeg2[index].disabled = true;
        }
      });

      representanteLegal.telRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.telRepreLeg2[index].disabled = true;
        }
      });

      representanteLegal.celRepreLegal.forEach((element, index) => {
        if (element) {
          this.$refs.celRepreLeg2[index].disabled = true;
        }
      });

      representanteLegal.emailRereLegal.forEach((element, index) => {
        if (element) {
          this.$refs.emailRepreLeg2[index].disabled = true;
        }
      });
      /* representanteLegal.cargo.forEach((element, index) => {
        if (element) {
          this.$refs.cargoRepreLeg2[index].disabled = true;
        }
      }); */
    },

    recoveryComites(dataComites) {
      /*
        contratista: false
        obras: false
        concesiones: false

        vivienda: false
        inmobiliario: "true"

        proveedores: false
        industriales: false
        especialidades: false
      */

      // infraestructura
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.especialidades = false;

      if (dataComites.contratista) {
        this.dataComites.contratista = dataComites.contratista;
      }
      if (dataComites.obras) {
        this.dataComites.obras = dataComites.obras;
      }
      if (dataComites.concesiones) {
        this.dataComites.concesiones = dataComites.concesiones;
      }

      // vivienda
      if (dataComites.vivienda) {
        this.dataComites.vivienda = dataComites.vivienda;
      }
      if (dataComites.inmobiliario) {
        this.dataComites.inmobiliario = dataComites.inmobiliario;
      }

      // suministros
      if (dataComites.proveedores) {
        this.dataComites.proveedores = dataComites.proveedores;
      }
      if (dataComites.industriales) {
        this.dataComites.industriales = dataComites.industriales;
      }
      if (dataComites.especialidades) {
        this.dataComites.especialidades = dataComites.especialidades;
      }
    },
  },

  watch: {
    // Observar cambios en el emailRepresentante
    'dataRepresentante.emailRepre': function(newEmail) {
        this.sameMailValidation(); // Llamar a la validación
    },
    'dataContactoCobranza.emailContacto': function(newEmail) {
        this.sameMailValidation(); // Llamar a la validación
    },
    // Observar cambios en los correos de Representante Legal
    'form.emailRereLegal': function(newEmails) {
        this.sameMailValidation(); // Llamar a la validación
    },
    // Observar cambios en los RUTs
    'dataRepresentante.rutRepre': function(newRut) {
        this.sameMailValidation(); // Llamar a la validación
    },
    'dataContactoCobranza.rutContactoCob': function(newRut) {
        this.sameMailValidation(); // Llamar a la validación
    },
    // Observar cambios en los RUTs de Representante Legal
    'form.rutRepreLegal': function(newRuts) {
        this.sameMailValidation(); // Llamar a la validación
    }
},
  computed: {
    ...mapState([
      "collapse",
      "telIsValid",
      "emailIsValid",
      "rutIsValid",
      "completedForm",
      "areas",
      "cargos",
      "cargosCob",
	    "cargosLegal",
      "selectedAreas",
      "selectedCargos",
      "selectedSexo",
      "selectedSexoContact",
      "selectedSexoRepre",
      "rutPatrocinanteGlobal",
      "rutRepresentanteCChCIsValid",
      "telRepresentanteCChCIsValid",
      "celRepresentanteCChCIsValid",
      "emailRepresentanteCChCIsValid",
      "cargoContactoIsValid",
      "cargoInputIsValid",
      "rutContactoCobIsValid",
      "telContactoCobIsValid",
      "celContactoCobIsValid",
      "emailContactoCobIsValid",
      "rutRepreLegalIsValid",
      "telRepreLegalIsValid",
      "celRepreLegalIsValid",
      "emailRepreLegalIsValid",
      "cargoRepreLegalIsValid",
      "sexoIsvalidate",
      "sexoIsvalidateContacto",
      "sexoIsvalidateRepreLeg2",
      "URL",
      "globalRequestNumber",
      "nroSolicitudGlobal",
      "selectedAreaContacto",
      "selectedAreasRepreLegal",
      "selectedCargoContacto",
      "selectedCargoContactoCob",
      "selectedCargoRepre",
      "selectedCargoRepreLegal",
      "validation",
    ]),

    // observerDataRepresentanteLegal () {
    //   return this.objectDataRepreLegal;
    // }
  },

  created() {
    this.getRut();
    this.getAreas();
    this.getCargos();
  },
  updated() {
    // if (this.$store.state.showStepFour && this.banderaActivarClases) {
    if (this.banderaActivarClases) {
      this.activateClassOffDinamicsForms();
    }
  },
};
</script>


<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style> -->
<style scoped>
:deep(.multiselect__tag) {
  background-color: #007bff !important; /* Color azul */
  color: white; /* Color del texto */
  border: none; /* Sin borde */
}

:deep(.multiselect__tag:hover) {
  background-color: #0056b3; /* Azul oscuro al pasar el cursor */
}

:deep(.multiselect__option) {
  background-color: white;
  color: #333; /* Texto negro */
}

:deep(.multiselect__option:hover) {
  background-color: #0056b3; /* Azul más oscuro cuando se pasa el cursor */
  color: white; /* Texto blanco */
}


.custom-select {
  height: 100px; /* Intenta ajustar esto */
  padding: 50px; /* Ajusta el padding si es necesario */
  margin: 10px;
  font-size: 16px; /* Cambia el tamaño de la fuente */
  width: 100%; /* Ajusta el ancho si es necesario */
  box-sizing: border-box; /* Asegúrate de que el padding no aumente el tamaño total */
}

.vm--modal {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: white;
  border-radius: 3px;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
  background: #185bc1;
  color: #fff;
  padding: 30px;
}

*:disabled {
  color: #ccc;
  border-color: #ccc;
}

.mx-input:disabled,
.mx-input.disabled {
  color: #ccc;
  background-color: #f0f0f0;
  z-index: initial;
  border-color: black;
}

i {
  z-index: 25;
}
label {
  z-index: 25;
}

select:disabled {
  opacity: 0.3;
}

.vm--modal .close-modal-text {
  cursor: pointer;
  position: absolute;
  font-size: 20px;
  top: 10px;
  right: 20px;
  color: #fff;
}

*:focus {
  outline: white;
}

.informacion {
  font-size: 14px;
}

.input-new {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-bottom: 30px;
}

.input-new .btn-blue {
  width: 100%;
  max-width: 280px;
}
.c-form-steps .c-form-steps__content.step-data p {
  margin-bottom: 35px;
}
button:disabled,
button[disabled]{
  border: 1px solid #999999 !important;
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed;
}

</style>